var _g, _rect, _rect2, _g2, _rect3, _rect4, _g3, _rect5, _rect6, _g4, _rect7, _rect8, _g5, _rect9, _rect10, _g6, _rect11, _rect12, _g7, _rect13, _rect14, _g8, _rect15, _rect16, _g9, _rect17, _rect18, _g10, _rect19, _rect20, _g11, _rect21, _rect22, _g12, _rect23, _rect24, _g13, _rect25, _rect26, _g14, _rect27, _rect28, _g15, _rect29, _rect30, _g16, _rect31, _rect32, _g17, _rect33, _rect34, _g18, _rect35, _rect36, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _rect37, _rect38, _g27, _rect39, _rect40, _g28, _rect41, _rect42, _g29, _rect43, _rect44, _g30, _rect45, _rect46, _g31, _rect47, _rect48, _g32, _rect49, _rect50, _g33, _rect51, _rect52, _g34, _rect53, _rect54, _g35, _rect55, _rect56, _g36, _rect57, _rect58, _g37, _rect59, _rect60, _g38, _rect61, _rect62, _g39, _rect63, _rect64, _g40, _rect65, _rect66, _g41, _rect67, _rect68, _g42, _rect69, _rect70, _g43, _rect71, _rect72, _g44, _g45, _g46, _g47, _g48, _g49, _g50, _g51, _rect73, _rect74, _g52, _rect75, _rect76, _g53, _rect77, _rect78, _g54, _rect79, _rect80, _g55, _rect81, _rect82, _g56, _rect83, _rect84, _g57, _rect85, _rect86, _g58, _rect87, _rect88, _g59, _rect89, _rect90, _g60, _rect91, _rect92, _g61, _rect93, _rect94, _g62, _rect95, _rect96, _g63, _rect97, _rect98, _g64, _rect99, _rect100, _g65, _rect101, _rect102, _g66, _rect103, _rect104, _g67, _rect105, _rect106, _g68, _rect107, _rect108, _g69, _g70, _g71, _g72, _g73, _g74, _g75, _g76, _rect109, _rect110, _g77, _rect111, _rect112, _g78, _rect113, _rect114, _g79, _rect115, _rect116, _g80, _rect117, _rect118, _g81, _rect119, _rect120, _g82, _rect121, _rect122, _g83, _rect123, _rect124, _g84, _rect125, _rect126, _g85, _rect127, _rect128, _g86, _rect129, _rect130, _g87, _rect131, _rect132, _g88, _rect133, _rect134, _g89, _rect135, _rect136, _g90, _rect137, _rect138, _g91, _rect139, _rect140, _g92, _rect141, _rect142, _g93, _rect143, _rect144, _g94, _g95, _g96, _g97, _g98, _g99, _g100, _g101, _rect145, _rect146, _g102, _rect147, _rect148, _g103, _rect149, _rect150, _g104, _rect151, _rect152, _g105, _rect153, _rect154, _g106, _rect155, _rect156, _g107, _rect157, _rect158, _g108, _rect159, _rect160, _g109, _rect161, _rect162, _g110, _rect163, _rect164, _g111, _rect165, _rect166, _g112, _rect167, _rect168, _g113, _rect169, _rect170, _g114, _rect171, _rect172, _g115, _rect173, _rect174, _g116, _rect175, _rect176, _g117, _rect177, _rect178, _g118, _rect179, _rect180, _g119, _g120, _g121, _g122, _g123, _g124, _g125, _g126, _g127, _g128, _g129, _rect181, _rect182, _g130, _rect183, _rect184, _g131, _rect185, _rect186, _g132, _rect187, _rect188, _g133, _rect189, _rect190, _g134, _rect191, _rect192, _g135, _rect193, _rect194, _g136, _rect195, _rect196, _g137, _rect197, _rect198, _g138, _rect199, _rect200, _g139, _rect201, _rect202, _g140, _rect203, _rect204, _g141, _rect205, _rect206, _g142, _rect207, _rect208, _g143, _rect209, _rect210, _g144, _rect211, _rect212, _g145, _rect213, _rect214, _g146, _rect215, _rect216, _g147, _g148, _g149, _g150, _g151, _g152, _g153, _g154, _rect217, _rect218, _g155, _rect219, _rect220, _g156, _rect221, _rect222, _g157, _rect223, _rect224, _g158, _rect225, _rect226, _g159, _rect227, _rect228, _g160, _rect229, _rect230, _g161, _rect231, _rect232, _g162, _rect233, _rect234, _g163, _rect235, _rect236, _g164, _rect237, _rect238, _g165, _rect239, _rect240, _g166, _rect241, _rect242, _g167, _rect243, _rect244, _g168, _rect245, _rect246, _g169, _rect247, _rect248, _g170, _rect249, _rect250, _g171, _rect251, _rect252, _g172, _g173, _g174, _g175, _g176, _g177, _g178, _g179, _g180, _g181, _g182, _g183, _g184, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpringHeader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 549,
    height: 405,
    viewBox: "0 0 549 405",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M148.285 222.182C146.781 216.571 150.111 210.803 155.722 209.3V209.3C161.333 207.797 167.1 211.126 168.604 216.737L179.922 258.979C181.426 264.59 178.096 270.357 172.485 271.861V271.861C166.874 273.364 161.107 270.035 159.603 264.424L148.285 222.182Z",
    fill: "#82E9CF"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 152.248,
    y: 226.278,
    width: 15.5,
    height: 49.2678,
    rx: 7.74999,
    transform: "rotate(-15 152.248 226.278)",
    fill: "#72D3B8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 156.248,
    y: 232.655,
    width: 11.0714,
    height: 42.0714,
    rx: 5.53571,
    transform: "rotate(-15 156.248 232.655)",
    fill: "#82E9CF"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M125.357 238.383C122.452 233.352 124.176 226.92 129.206 224.015V224.015C134.237 221.111 140.67 222.834 143.574 227.865L165.44 265.738C168.344 270.769 166.621 277.201 161.59 280.106V280.106C156.56 283.01 150.127 281.287 147.223 276.256L125.357 238.383Z",
    fill: "#82E9CF"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 130.244,
    y: 241.313,
    width: 15.5,
    height: 49.2678,
    rx: 7.74999,
    transform: "rotate(-30 130.244 241.313)",
    fill: "#72D3B8"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 135.761,
    y: 246.44,
    width: 11.0714,
    height: 42.0714,
    rx: 5.53571,
    transform: "rotate(-30 135.761 246.44)",
    fill: "#82E9CF"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M109.279 266.035C104.248 263.131 102.524 256.698 105.429 251.667V251.667C108.333 246.637 114.766 244.913 119.796 247.818L157.67 269.684C162.7 272.588 164.424 279.021 161.519 284.051V284.051C158.615 289.082 152.182 290.806 147.152 287.901L109.279 266.035Z",
    fill: "#82E9CF"
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 114.977,
    y: 266.13,
    width: 15.5,
    height: 49.2678,
    rx: 7.74999,
    transform: "rotate(-60 114.977 266.13)",
    fill: "#72D3B8"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 122.317,
    y: 267.809,
    width: 11.0714,
    height: 42.0714,
    rx: 5.53571,
    transform: "rotate(-60 122.317 267.809)",
    fill: "#82E9CF"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M104.24 292.172C98.6286 290.669 95.2989 284.901 96.8023 279.29V279.29C98.3057 273.68 104.073 270.35 109.684 271.853L151.926 283.172C157.537 284.675 160.867 290.443 159.363 296.054V296.054C157.86 301.665 152.092 304.994 146.481 303.491L104.24 292.172Z",
    fill: "#82E9CF"
  }))), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 109.769,
    y: 290.79,
    width: 15.5,
    height: 49.2678,
    rx: 7.74999,
    transform: "rotate(-75 109.769 290.79)",
    fill: "#72D3B8"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 117.293,
    y: 290.512,
    width: 11.0714,
    height: 42.0714,
    rx: 5.53571,
    transform: "rotate(-75 117.293 290.512)",
    fill: "#82E9CF"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M113.559 323.417C107.948 324.921 102.181 321.591 100.677 315.98V315.98C99.1738 310.369 102.504 304.602 108.114 303.098L150.356 291.78C155.967 290.276 161.735 293.606 163.238 299.217V299.217C164.742 304.828 161.412 310.595 155.801 312.099L113.559 323.417Z",
    fill: "#82E9CF"
  }))), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 117.655,
    y: 319.456,
    width: 15.5,
    height: 49.2678,
    rx: 7.74999,
    transform: "rotate(-105 117.655 319.456)",
    fill: "#72D3B8"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 124.033,
    y: 315.454,
    width: 11.0714,
    height: 42.0714,
    rx: 5.53571,
    transform: "rotate(-105 124.033 315.454)",
    fill: "#82E9CF"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120.349 349.347C115.318 352.252 108.886 350.528 105.981 345.497V345.497C103.077 340.467 104.801 334.034 109.831 331.13L147.704 309.264C152.735 306.359 159.167 308.083 162.072 313.114V313.114C164.976 318.144 163.253 324.577 158.222 327.481L120.349 349.347Z",
    fill: "#82E9CF"
  }))), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 123.279,
    y: 344.46,
    width: 15.5,
    height: 49.2678,
    rx: 7.74999,
    transform: "rotate(-120 123.279 344.46)",
    fill: "#72D3B8"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 128.404,
    y: 338.942,
    width: 11.0714,
    height: 42.0714,
    rx: 5.53571,
    transform: "rotate(-120 128.404 338.942)",
    fill: "#82E9CF"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M146.343 370.365C143.438 375.395 137.006 377.119 131.975 374.214V374.214C126.945 371.31 125.221 364.877 128.125 359.847L149.992 321.974C152.896 316.943 159.329 315.219 164.359 318.124V318.124C169.39 321.028 171.113 327.461 168.209 332.492L146.343 370.365Z",
    fill: "#82E9CF"
  }))), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 146.437,
    y: 364.665,
    width: 15.5,
    height: 49.2678,
    rx: 7.74999,
    transform: "rotate(-150 146.437 364.665)",
    fill: "#72D3B8"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 148.117,
    y: 357.325,
    width: 11.0714,
    height: 42.0714,
    rx: 5.53571,
    transform: "rotate(-150 148.117 357.325)",
    fill: "#82E9CF"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M169.71 380.671C168.207 386.282 162.44 389.612 156.829 388.109V388.109C151.218 386.605 147.888 380.838 149.392 375.227L160.71 332.985C162.214 327.374 167.981 324.044 173.592 325.548V325.548C179.203 327.051 182.533 332.818 181.029 338.429L169.71 380.671Z",
    fill: "#82E9CF"
  }))), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 168.327,
    y: 375.144,
    width: 15.5,
    height: 49.2678,
    rx: 7.74999,
    transform: "rotate(-165 168.327 375.144)",
    fill: "#72D3B8"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 168.05,
    y: 367.62,
    width: 11.0714,
    height: 42.0714,
    rx: 5.53571,
    transform: "rotate(-165 168.05 367.62)",
    fill: "#82E9CF"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 197.598,
    y: 393.13,
    width: 21.0357,
    height: 64.7678,
    rx: 10.5178,
    transform: "rotate(180 197.598 393.13)",
    fill: "#82E9CF"
  }))), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 194.83,
    y: 377.63,
    width: 15.5,
    height: 49.2678,
    rx: 7.74999,
    transform: "rotate(180 194.83 377.63)",
    fill: "#72D3B8"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 192.615,
    y: 370.434,
    width: 11.0714,
    height: 42.0714,
    rx: 5.53571,
    transform: "rotate(180 192.615 370.434)",
    fill: "#82E9CF"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M225.875 376.972C227.379 382.583 224.049 388.35 218.438 389.854V389.854C212.827 391.357 207.06 388.027 205.557 382.417L194.238 340.175C192.734 334.564 196.064 328.796 201.675 327.293V327.293C207.286 325.789 213.053 329.119 214.557 334.73L225.875 376.972Z",
    fill: "#82E9CF"
  }))), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 221.912,
    y: 372.876,
    width: 15.5,
    height: 49.2678,
    rx: 7.74999,
    transform: "rotate(165 221.912 372.876)",
    fill: "#72D3B8"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 217.911,
    y: 366.499,
    width: 11.0714,
    height: 42.0714,
    rx: 5.53571,
    transform: "rotate(165 217.911 366.499)",
    fill: "#82E9CF"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M248.804 360.771C251.708 365.802 249.984 372.234 244.954 375.139V375.139C239.923 378.043 233.491 376.319 230.586 371.289L208.72 333.416C205.816 328.385 207.539 321.952 212.57 319.048V319.048C217.601 316.144 224.033 317.867 226.938 322.898L248.804 360.771Z",
    fill: "#82E9CF"
  }))), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 243.916,
    y: 357.841,
    width: 15.5,
    height: 49.2678,
    rx: 7.74999,
    transform: "rotate(150 243.916 357.841)",
    fill: "#72D3B8"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 238.399,
    y: 352.714,
    width: 11.0714,
    height: 42.0714,
    rx: 5.53571,
    transform: "rotate(150 238.399 352.714)",
    fill: "#82E9CF"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter11_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M264.882 333.119C269.912 336.023 271.636 342.456 268.731 347.486V347.486C265.827 352.517 259.394 354.241 254.364 351.336L216.491 329.47C211.46 326.566 209.736 320.133 212.641 315.103V315.103C215.545 310.072 221.978 308.348 227.008 311.253L264.882 333.119Z",
    fill: "#82E9CF"
  }))), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 259.184,
    y: 333.024,
    width: 15.5,
    height: 49.2678,
    rx: 7.74999,
    transform: "rotate(120 259.184 333.024)",
    fill: "#72D3B8"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 251.843,
    y: 331.344,
    width: 11.0714,
    height: 42.0714,
    rx: 5.53571,
    transform: "rotate(120 251.843 331.344)",
    fill: "#82E9CF"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter12_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M269.921 306.982C275.532 308.485 278.861 314.252 277.358 319.863V319.863C275.854 325.474 270.087 328.804 264.476 327.301L222.234 315.982C216.623 314.478 213.294 308.711 214.797 303.1V303.1C216.3 297.489 222.068 294.159 227.679 295.663L269.921 306.982Z",
    fill: "#82E9CF"
  }))), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 264.392,
    y: 308.364,
    width: 15.5,
    height: 49.2678,
    rx: 7.74999,
    transform: "rotate(105 264.392 308.364)",
    fill: "#72D3B8"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 256.868,
    y: 308.641,
    width: 11.0714,
    height: 42.0714,
    rx: 5.53571,
    transform: "rotate(105 256.868 308.641)",
    fill: "#82E9CF"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter13_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M260.601 275.737C266.212 274.233 271.98 277.563 273.483 283.174V283.174C274.986 288.785 271.657 294.552 266.046 296.056L223.804 307.374C218.193 308.878 212.426 305.548 210.922 299.937V299.937C209.419 294.326 212.748 288.559 218.359 287.055L260.601 275.737Z",
    fill: "#82E9CF"
  }))), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 256.505,
    y: 279.698,
    width: 15.5,
    height: 49.2678,
    rx: 7.74999,
    transform: "rotate(75 256.505 279.698)",
    fill: "#72D3B8"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 250.127,
    y: 283.7,
    width: 11.0714,
    height: 42.0714,
    rx: 5.53571,
    transform: "rotate(75 250.127 283.7)",
    fill: "#82E9CF"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter14_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M253.811 249.807C258.842 246.902 265.274 248.626 268.179 253.656V253.656C271.083 258.687 269.36 265.12 264.329 268.024L226.456 289.89C221.425 292.794 214.993 291.071 212.088 286.04V286.04C209.184 281.01 210.907 274.577 215.938 271.673L253.811 249.807Z",
    fill: "#82E9CF"
  }))), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 250.88,
    y: 254.694,
    width: 15.5,
    height: 49.2678,
    rx: 7.74999,
    transform: "rotate(60 250.88 254.694)",
    fill: "#72D3B8"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 245.755,
    y: 260.212,
    width: 11.0714,
    height: 42.0714,
    rx: 5.53571,
    transform: "rotate(60 245.755 260.212)",
    fill: "#82E9CF"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter15_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M227.817 228.789C230.722 223.759 237.154 222.035 242.185 224.939V224.939C247.216 227.844 248.939 234.276 246.035 239.307L224.169 277.18C221.264 282.211 214.832 283.934 209.801 281.03V281.03C204.77 278.125 203.047 271.693 205.951 266.662L227.817 228.789Z",
    fill: "#82E9CF"
  }))), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 227.724,
    y: 234.489,
    width: 15.5,
    height: 49.2678,
    rx: 7.74999,
    transform: "rotate(30 227.724 234.489)",
    fill: "#72D3B8"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 226.043,
    y: 241.829,
    width: 11.0714,
    height: 42.0714,
    rx: 5.53571,
    transform: "rotate(30 226.043 241.829)",
    fill: "#82E9CF"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter16_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M204.45 218.482C205.953 212.872 211.72 209.542 217.331 211.045V211.045C222.942 212.549 226.272 218.316 224.769 223.927L213.45 266.169C211.946 271.78 206.179 275.11 200.568 273.606V273.606C194.957 272.103 191.628 266.335 193.131 260.724L204.45 218.482Z",
    fill: "#82E9CF"
  }))), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 205.833,
    y: 224.01,
    width: 15.5,
    height: 49.2678,
    rx: 7.74999,
    transform: "rotate(15 205.833 224.01)",
    fill: "#72D3B8"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 206.11,
    y: 231.534,
    width: 11.0714,
    height: 42.0714,
    rx: 5.53571,
    transform: "rotate(15 206.11 231.534)",
    fill: "#82E9CF"
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter17_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M176.563 216.542C176.563 210.733 181.271 206.024 187.08 206.024V206.024C192.889 206.024 197.598 210.733 197.598 216.542L197.598 260.274C197.598 266.083 192.889 270.792 187.08 270.792V270.792C181.271 270.792 176.563 266.083 176.563 260.274L176.563 216.542Z",
    fill: "#82E9CF"
  }))), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 179.33,
    y: 221.524,
    width: 15.5,
    height: 49.2678,
    rx: 7.74999,
    fill: "#72D3B8"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 181.545,
    y: 228.719,
    width: 11.0714,
    height: 42.0714,
    rx: 5.53571,
    fill: "#82E9CF"
  })), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter18_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 203.134,
    y: 353.274,
    width: 32.1071,
    height: 58.1249,
    rx: 16.0536,
    transform: "rotate(180 203.134 353.274)",
    fill: "#F4D5AD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 197.599,
    y: 337.774,
    width: 21.0357,
    height: 38.1964,
    rx: 10.5178,
    transform: "rotate(180 197.599 337.774)",
    fill: "#F4C283"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 193.723,
    y: 328.362,
    width: 13.2857,
    height: 23.8035,
    rx: 6.64285,
    transform: "rotate(180 193.723 328.362)",
    fill: "#F4D5AD"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter19_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 132.277,
    y: 279.1,
    width: 32.1071,
    height: 58.1249,
    rx: 16.0536,
    transform: "rotate(-45 132.277 279.1)",
    fill: "#F4D5AD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147.151,
    y: 286.147,
    width: 21.0357,
    height: 38.1964,
    rx: 10.5178,
    transform: "rotate(-45 147.151 286.147)",
    fill: "#F4C283"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.546,
    y: 290.061,
    width: 13.2857,
    height: 23.8035,
    rx: 6.64285,
    transform: "rotate(-45 156.546 290.061)",
    fill: "#F4D5AD"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter20_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 148.33,
    y: 340.391,
    width: 32.1071,
    height: 58.1249,
    rx: 16.0536,
    transform: "rotate(-120 148.33 340.391)",
    fill: "#F4D5AD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158.985,
    y: 327.846,
    width: 21.0357,
    height: 38.1964,
    rx: 10.5178,
    transform: "rotate(-120 158.985 327.846)",
    fill: "#F4C283"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165.198,
    y: 319.786,
    width: 13.2857,
    height: 23.8035,
    rx: 6.64285,
    transform: "rotate(-120 165.198 319.786)",
    fill: "#F4D5AD"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter21_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 242.4,
    y: 321.563,
    width: 32.1071,
    height: 58.1249,
    rx: 16.0536,
    transform: "rotate(135 242.4 321.563)",
    fill: "#F4D5AD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 227.525,
    y: 314.516,
    width: 21.0357,
    height: 38.1964,
    rx: 10.5178,
    transform: "rotate(135 227.525 314.516)",
    fill: "#F4C283"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218.132,
    y: 310.602,
    width: 13.2857,
    height: 23.8035,
    rx: 6.64285,
    transform: "rotate(135 218.132 310.602)",
    fill: "#F4D5AD"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter22_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 226.347,
    y: 260.274,
    width: 32.1071,
    height: 58.1249,
    rx: 16.0536,
    transform: "rotate(60 226.347 260.274)",
    fill: "#F4D5AD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215.69,
    y: 272.817,
    width: 21.0357,
    height: 38.1964,
    rx: 10.5178,
    transform: "rotate(60 215.69 272.817)",
    fill: "#F4C283"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 209.479,
    y: 280.88,
    width: 13.2857,
    height: 23.8035,
    rx: 6.64285,
    transform: "rotate(60 209.479 280.88)",
    fill: "#F4D5AD"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter23_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 171.027,
    y: 245.327,
    width: 32.1071,
    height: 58.1249,
    rx: 16.0536,
    fill: "#F4D5AD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176.562,
    y: 260.827,
    width: 21.0357,
    height: 38.1964,
    rx: 10.5178,
    fill: "#F4C283"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180.438,
    y: 270.237,
    width: 13.2857,
    height: 23.8035,
    rx: 6.64285,
    fill: "#F4D5AD"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter24_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M187.08 273.005C188.914 273.005 190.401 274.492 190.402 276.326C190.402 277.823 189.41 279.089 188.048 279.504V280.225C194.978 280.571 200.933 284.612 203.988 290.417L204.828 289.932C204.578 288.587 205.182 287.171 206.435 286.448C208.023 285.531 210.055 286.076 210.972 287.664C211.889 289.252 211.344 291.284 209.756 292.201C208.459 292.95 206.867 292.725 205.827 291.753L204.859 292.311C205.71 294.476 206.178 296.834 206.178 299.301C206.178 301.533 205.793 303.675 205.089 305.667L207.463 308.04C208.698 307.45 210.221 307.667 211.243 308.689C212.54 309.986 212.54 312.089 211.243 313.387C209.946 314.684 207.843 314.684 206.546 313.387C205.487 312.328 205.293 310.732 205.963 309.475L204.219 307.731C201.258 313.738 195.235 317.962 188.187 318.365V319.693C189.477 320.149 190.402 321.38 190.402 322.826C190.401 324.66 188.914 326.147 187.079 326.147C185.245 326.147 183.758 324.66 183.758 322.826C183.758 321.328 184.75 320.063 186.111 319.648V318.374C179.904 318.064 174.477 314.791 171.217 309.939L169.847 310.731C170.097 312.076 169.494 313.492 168.241 314.215C166.653 315.132 164.622 314.588 163.704 313C162.787 311.411 163.331 309.379 164.92 308.462C166.217 307.713 167.809 307.939 168.849 308.911L170.155 308.156C168.768 305.509 167.982 302.497 167.982 299.301C167.982 297.5 168.231 295.757 168.696 294.105L167.213 292.622C165.979 293.211 164.455 292.995 163.433 291.972C162.136 290.675 162.136 288.572 163.433 287.275C164.73 285.978 166.833 285.978 168.13 287.275C169.189 288.334 169.383 289.93 168.713 291.186L169.456 291.929C172.205 285.364 178.516 280.66 185.973 280.234V279.459C184.683 279.003 183.758 277.772 183.758 276.326C183.758 274.492 185.246 273.005 187.08 273.005Z",
    fill: "white"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter25_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.4958 194.607C64.0975 189.388 67.1945 184.024 72.4133 182.625V182.625C77.632 181.227 82.9963 184.324 84.3946 189.543L94.9222 228.832C96.3206 234.051 93.2236 239.415 88.0048 240.814V240.814C82.786 242.212 77.4218 239.115 76.0234 233.896L65.4958 194.607Z",
    fill: "white"
  }))), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 69.1816,
    y: 198.417,
    width: 14.4167,
    height: 45.8244,
    rx: 7.20833,
    transform: "rotate(-15 69.1816 198.417)",
    fill: "#E2E2E2"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 72.9033,
    y: 204.347,
    width: 10.2976,
    height: 39.131,
    rx: 5.14881,
    transform: "rotate(-15 72.9033 204.347)",
    fill: "white"
  })), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter26_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.1707 209.674C41.4692 204.995 43.0724 199.012 47.7514 196.311V196.311C52.4304 193.609 58.4134 195.212 61.1149 199.891L81.4527 235.117C84.1541 239.796 82.5509 245.779 77.8719 248.481V248.481C73.1929 251.182 67.2099 249.579 64.5085 244.9L44.1707 209.674Z",
    fill: "white"
  }))), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 48.7168,
    y: 212.401,
    width: 14.4167,
    height: 45.8244,
    rx: 7.20833,
    transform: "rotate(-30 48.7168 212.401)",
    fill: "#E2E2E2"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 53.8477,
    y: 217.167,
    width: 10.2976,
    height: 39.131,
    rx: 5.14881,
    transform: "rotate(-30 53.8477 217.167)",
    fill: "white"
  })), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter27_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.2162 235.394C24.5372 232.693 22.9341 226.71 25.6355 222.031V222.031C28.3369 217.352 34.32 215.748 38.999 218.45L74.2251 238.788C78.9041 241.489 80.5072 247.472 77.8058 252.151V252.151C75.1044 256.83 69.1213 258.433 64.4423 255.732L29.2162 235.394Z",
    fill: "white"
  }))), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 34.5166,
    y: 235.481,
    width: 14.4167,
    height: 45.8244,
    rx: 7.20833,
    transform: "rotate(-60 34.5166 235.481)",
    fill: "#E2E2E2"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 41.3428,
    y: 237.046,
    width: 10.2976,
    height: 39.131,
    rx: 5.14881,
    transform: "rotate(-60 41.3428 237.046)",
    fill: "white"
  })), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter28_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.5295 259.704C19.3107 258.306 16.2137 252.942 17.612 247.723V247.723C19.0104 242.504 24.3746 239.407 29.5934 240.806L68.883 251.333C74.1018 252.732 77.1988 258.096 75.8004 263.315V263.315C74.4021 268.533 69.0378 271.63 63.8191 270.232L24.5295 259.704Z",
    fill: "white"
  }))), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 29.6719,
    y: 258.419,
    width: 14.4167,
    height: 45.8244,
    rx: 7.20833,
    transform: "rotate(-75 29.6719 258.419)",
    fill: "#E2E2E2"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 36.6699,
    y: 258.159,
    width: 10.2976,
    height: 39.131,
    rx: 5.14881,
    transform: "rotate(-75 36.6699 258.159)",
    fill: "white"
  })), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter29_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.1974 288.767C27.9787 290.166 22.6145 287.069 21.2161 281.85V281.85C19.8177 276.631 22.9148 271.267 28.1335 269.869L67.4231 259.341C72.6419 257.943 78.0061 261.04 79.4045 266.258V266.258C80.8029 271.477 77.7058 276.841 72.487 278.24L33.1974 288.767Z",
    fill: "white"
  }))), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 37.0068,
    y: 285.081,
    width: 14.4167,
    height: 45.8244,
    rx: 7.20833,
    transform: "rotate(-105 37.0068 285.081)",
    fill: "#E2E2E2"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 42.9395,
    y: 281.36,
    width: 10.2976,
    height: 39.131,
    rx: 5.14881,
    transform: "rotate(-105 42.9395 281.36)",
    fill: "white"
  })), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter30_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.5131 312.885C34.8341 315.586 28.8511 313.983 26.1496 309.304V309.304C23.4482 304.625 25.0514 298.642 29.7304 295.941L64.9565 275.603C69.6355 272.901 75.6185 274.504 78.3199 279.183V279.183C81.0214 283.862 79.4182 289.846 74.7392 292.547L39.5131 312.885Z",
    fill: "white"
  }))), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 42.2393,
    y: 308.339,
    width: 14.4167,
    height: 45.8244,
    rx: 7.20833,
    transform: "rotate(-120 42.2393 308.339)",
    fill: "#E2E2E2"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 47.0059,
    y: 303.206,
    width: 10.2976,
    height: 39.131,
    rx: 5.14881,
    transform: "rotate(-120 47.0059 303.206)",
    fill: "white"
  })), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter31_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.6892 332.431C60.9878 337.11 55.0048 338.713 50.3258 336.012V336.012C45.6467 333.31 44.0436 327.327 46.745 322.648L67.0828 287.422C69.7843 282.743 75.7673 281.14 80.4463 283.842V283.842C85.1253 286.543 86.7284 292.526 84.027 297.205L63.6892 332.431Z",
    fill: "white"
  }))), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 63.7764,
    y: 327.132,
    width: 14.4167,
    height: 45.8244,
    rx: 7.20833,
    transform: "rotate(-150 63.7764 327.132)",
    fill: "#E2E2E2"
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 65.3398,
    y: 320.303,
    width: 10.2976,
    height: 39.131,
    rx: 5.14881,
    transform: "rotate(-150 65.3398 320.303)",
    fill: "white"
  })), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter32_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.4245 342.02C84.0262 347.239 78.6619 350.336 73.4432 348.938V348.938C68.2244 347.539 65.1274 342.175 66.5257 336.956L77.0534 297.667C78.4517 292.448 83.816 289.351 89.0347 290.749V290.749C94.2535 292.147 97.3505 297.512 95.9522 302.73L85.4245 342.02Z",
    fill: "white"
  }))), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 84.1367,
    y: 336.876,
    width: 14.4167,
    height: 45.8244,
    rx: 7.20833,
    transform: "rotate(-165 84.1367 336.876)",
    fill: "#E2E2E2"
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 83.8799,
    y: 329.878,
    width: 10.2976,
    height: 39.131,
    rx: 5.14881,
    transform: "rotate(-165 83.8799 329.878)",
    fill: "white"
  })), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter33_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 111.363,
    y: 353.606,
    width: 19.5655,
    height: 60.2411,
    rx: 9.78274,
    transform: "rotate(180 111.363 353.606)",
    fill: "white"
  }))), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 108.789,
    y: 339.19,
    width: 14.4167,
    height: 45.8244,
    rx: 7.20833,
    transform: "rotate(180 108.789 339.19)",
    fill: "#E2E2E2"
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: 106.729,
    y: 332.497,
    width: 10.2976,
    height: 39.131,
    rx: 5.14881,
    transform: "rotate(180 106.729 332.497)",
    fill: "white"
  })), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter34_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M137.664 338.577C139.063 343.795 135.966 349.16 130.747 350.558V350.558C125.528 351.956 120.164 348.859 118.766 343.641L108.238 304.351C106.84 299.132 109.937 293.768 115.155 292.37V292.37C120.374 290.971 125.738 294.068 127.137 299.287L137.664 338.577Z",
    fill: "white"
  }))), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    x: 133.979,
    y: 334.768,
    width: 14.4167,
    height: 45.8244,
    rx: 7.20833,
    transform: "rotate(165 133.979 334.768)",
    fill: "#E2E2E2"
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    x: 130.257,
    y: 328.837,
    width: 10.2976,
    height: 39.131,
    rx: 5.14881,
    transform: "rotate(165 130.257 328.837)",
    fill: "white"
  })), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter35_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M158.989 323.509C161.691 328.188 160.088 334.171 155.409 336.873V336.873C150.73 339.574 144.747 337.971 142.045 333.292L121.707 298.066C119.006 293.387 120.609 287.404 125.288 284.702V284.702C129.967 282.001 135.95 283.604 138.652 288.283L158.989 323.509Z",
    fill: "white"
  }))), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    x: 154.443,
    y: 320.784,
    width: 14.4167,
    height: 45.8244,
    rx: 7.20833,
    transform: "rotate(150 154.443 320.784)",
    fill: "#E2E2E2"
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    x: 149.312,
    y: 316.016,
    width: 10.2976,
    height: 39.131,
    rx: 5.14881,
    transform: "rotate(150 149.312 316.016)",
    fill: "white"
  })), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter36_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M173.944 297.791C178.623 300.492 180.226 306.475 177.525 311.154V311.154C174.823 315.833 168.84 317.437 164.161 314.735L128.935 294.397C124.256 291.696 122.653 285.713 125.354 281.034V281.034C128.056 276.355 134.039 274.752 138.718 277.453L173.944 297.791Z",
    fill: "white"
  }))), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    x: 168.644,
    y: 297.702,
    width: 14.4167,
    height: 45.8244,
    rx: 7.20833,
    transform: "rotate(120 168.644 297.702)",
    fill: "#E2E2E2"
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    x: 161.817,
    y: 296.139,
    width: 10.2976,
    height: 39.131,
    rx: 5.14881,
    transform: "rotate(120 161.817 296.139)",
    fill: "white"
  })), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter37_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M178.631 273.48C183.849 274.879 186.946 280.243 185.548 285.462V285.462C184.15 290.681 178.786 293.778 173.567 292.379L134.277 281.852C129.058 280.453 125.961 275.089 127.36 269.87V269.87C128.758 264.652 134.122 261.555 139.341 262.953L178.631 273.48Z",
    fill: "white"
  }))), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    x: 173.488,
    y: 274.766,
    width: 14.4167,
    height: 45.8244,
    rx: 7.20833,
    transform: "rotate(105 173.488 274.766)",
    fill: "#E2E2E2"
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    x: 166.49,
    y: 275.024,
    width: 10.2976,
    height: 39.131,
    rx: 5.14881,
    transform: "rotate(105 166.49 275.024)",
    fill: "white"
  })), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter38_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M169.963 244.417C175.181 243.019 180.546 246.116 181.944 251.335V251.335C183.342 256.554 180.245 261.918 175.027 263.316L135.737 273.844C130.518 275.242 125.154 272.145 123.756 266.926V266.926C122.357 261.708 125.454 256.343 130.673 254.945L169.963 244.417Z",
    fill: "white"
  }))), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    x: 166.152,
    y: 248.102,
    width: 14.4167,
    height: 45.8244,
    rx: 7.20833,
    transform: "rotate(75 166.152 248.102)",
    fill: "#E2E2E2"
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    x: 160.221,
    y: 251.825,
    width: 10.2976,
    height: 39.131,
    rx: 5.14881,
    transform: "rotate(75 160.221 251.825)",
    fill: "white"
  })), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter39_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M163.647 220.3C168.326 217.599 174.309 219.202 177.011 223.881V223.881C179.712 228.56 178.109 234.543 173.43 237.245L138.204 257.582C133.525 260.284 127.542 258.681 124.84 254.002V254.002C122.139 249.323 123.742 243.34 128.421 240.638L163.647 220.3Z",
    fill: "white"
  }))), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    x: 160.921,
    y: 224.846,
    width: 14.4167,
    height: 45.8244,
    rx: 7.20833,
    transform: "rotate(60 160.921 224.846)",
    fill: "#E2E2E2"
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    x: 156.154,
    y: 229.977,
    width: 10.2976,
    height: 39.131,
    rx: 5.14881,
    transform: "rotate(60 156.154 229.977)",
    fill: "white"
  })), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter40_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M139.471 200.752C142.172 196.073 148.155 194.47 152.834 197.171V197.171C157.513 199.873 159.117 205.856 156.415 210.535L136.077 245.761C133.376 250.44 127.393 252.043 122.714 249.342V249.342C118.035 246.64 116.432 240.657 119.133 235.978L139.471 200.752Z",
    fill: "white"
  }))), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    x: 139.383,
    y: 206.053,
    width: 14.4167,
    height: 45.8244,
    rx: 7.20833,
    transform: "rotate(30 139.383 206.053)",
    fill: "#E2E2E2"
  })), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    x: 137.82,
    y: 212.882,
    width: 10.2976,
    height: 39.131,
    rx: 5.14881,
    transform: "rotate(30 137.82 212.882)",
    fill: "white"
  })), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter41_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M117.736 191.165C119.134 185.946 124.498 182.849 129.717 184.248V184.248C134.936 185.646 138.033 191.01 136.634 196.229L126.107 235.519C124.708 240.737 119.344 243.834 114.125 242.436V242.436C108.907 241.038 105.81 235.673 107.208 230.455L117.736 191.165Z",
    fill: "white"
  }))), _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    x: 119.022,
    y: 196.307,
    width: 14.4167,
    height: 45.8244,
    rx: 7.20833,
    transform: "rotate(15 119.022 196.307)",
    fill: "#E2E2E2"
  })), _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    x: 119.28,
    y: 203.305,
    width: 10.2976,
    height: 39.131,
    rx: 5.14881,
    transform: "rotate(15 119.28 203.305)",
    fill: "white"
  })), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter42_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.7979 189.36C91.7979 183.957 96.1777 179.577 101.581 179.577V179.577C106.983 179.577 111.363 183.957 111.363 189.36L111.363 230.035C111.363 235.438 106.983 239.818 101.581 239.818V239.818C96.1777 239.818 91.7979 235.438 91.7979 230.035L91.7979 189.36Z",
    fill: "white"
  }))), _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
    x: 94.3721,
    y: 193.993,
    width: 14.4167,
    height: 45.8244,
    rx: 7.20833,
    fill: "#E2E2E2"
  })), _rect72 || (_rect72 = /*#__PURE__*/React.createElement("rect", {
    x: 96.4316,
    y: 200.686,
    width: 10.2976,
    height: 39.131,
    rx: 5.14881,
    fill: "white"
  })), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter43_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 116.512,
    y: 316.536,
    width: 29.8631,
    height: 54.0625,
    rx: 14.9315,
    transform: "rotate(180 116.512 316.536)",
    fill: "#F4D5AD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 111.363,
    y: 302.118,
    width: 19.5655,
    height: 35.5268,
    rx: 9.78274,
    transform: "rotate(180 111.363 302.118)",
    fill: "#F4C283"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.759,
    y: 293.366,
    width: 12.3571,
    height: 22.1399,
    rx: 6.17857,
    transform: "rotate(180 107.759 293.366)",
    fill: "#F4D5AD"
  }))), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter44_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 50.6074,
    y: 247.548,
    width: 29.8631,
    height: 54.0625,
    rx: 14.9315,
    transform: "rotate(-45 50.6074 247.548)",
    fill: "#F4D5AD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.4424,
    y: 254.102,
    width: 19.5655,
    height: 35.5268,
    rx: 9.78274,
    transform: "rotate(-45 64.4424 254.102)",
    fill: "#F4C283"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73.1797,
    y: 257.743,
    width: 12.3571,
    height: 22.1399,
    rx: 6.17857,
    transform: "rotate(-45 73.1797 257.743)",
    fill: "#F4D5AD"
  }))), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter45_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 65.5391,
    y: 304.553,
    width: 29.8631,
    height: 54.0625,
    rx: 14.9315,
    transform: "rotate(-120 65.5391 304.553)",
    fill: "#F4D5AD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75.4492,
    y: 292.886,
    width: 19.5655,
    height: 35.5268,
    rx: 9.78274,
    transform: "rotate(-120 75.4492 292.886)",
    fill: "#F4C283"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.2275,
    y: 285.388,
    width: 12.3571,
    height: 22.1399,
    rx: 6.17857,
    transform: "rotate(-120 81.2275 285.388)",
    fill: "#F4D5AD"
  }))), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter46_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 153.035,
    y: 287.042,
    width: 29.8631,
    height: 54.0625,
    rx: 14.9315,
    transform: "rotate(135 153.035 287.042)",
    fill: "#F4D5AD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.2,
    y: 280.487,
    width: 19.5655,
    height: 35.5268,
    rx: 9.78274,
    transform: "rotate(135 139.2 280.487)",
    fill: "#F4C283"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130.462,
    y: 276.849,
    width: 12.3571,
    height: 22.1399,
    rx: 6.17857,
    transform: "rotate(135 130.462 276.849)",
    fill: "#F4D5AD"
  }))), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter47_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 138.103,
    y: 230.036,
    width: 29.8631,
    height: 54.0625,
    rx: 14.9315,
    transform: "rotate(60 138.103 230.036)",
    fill: "#F4D5AD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.191,
    y: 241.702,
    width: 19.5655,
    height: 35.5268,
    rx: 9.78274,
    transform: "rotate(60 128.191 241.702)",
    fill: "#F4C283"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.413,
    y: 249.2,
    width: 12.3571,
    height: 22.1399,
    rx: 6.17857,
    transform: "rotate(60 122.413 249.2)",
    fill: "#F4D5AD"
  }))), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter48_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 86.6494,
    y: 216.134,
    width: 29.8631,
    height: 54.0625,
    rx: 14.9315,
    fill: "#F4D5AD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.7979,
    y: 230.55,
    width: 19.5655,
    height: 35.5268,
    rx: 9.78274,
    fill: "#F4C283"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95.4023,
    y: 239.304,
    width: 12.3571,
    height: 22.1399,
    rx: 6.17857,
    fill: "#F4D5AD"
  }))), _g50 || (_g50 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter49_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M101.58 241.878C103.286 241.878 104.669 243.261 104.669 244.967C104.669 246.359 103.748 247.537 102.481 247.923V248.594C108.926 248.916 114.465 252.673 117.307 258.072L118.088 257.622C117.856 256.371 118.417 255.054 119.582 254.382C121.059 253.529 122.949 254.035 123.802 255.512C124.655 256.99 124.149 258.879 122.671 259.732C121.465 260.429 119.984 260.219 119.017 259.315L118.116 259.835C118.908 261.848 119.343 264.041 119.343 266.335C119.343 268.411 118.985 270.404 118.33 272.257L120.538 274.465C121.686 273.916 123.103 274.117 124.054 275.068C125.261 276.275 125.261 278.231 124.054 279.437C122.848 280.644 120.892 280.644 119.685 279.437C118.7 278.452 118.52 276.968 119.143 275.8L117.52 274.177C114.766 279.764 109.164 283.693 102.609 284.067V285.302C103.809 285.727 104.669 286.871 104.669 288.217C104.668 289.923 103.286 291.305 101.58 291.305C99.8736 291.305 98.491 289.923 98.4908 288.217C98.4908 286.824 99.4125 285.646 100.679 285.26V284.075C94.9059 283.787 89.8591 280.742 86.8267 276.23L85.5513 276.968C85.7839 278.219 85.2227 279.535 84.0582 280.208C82.5806 281.061 80.6905 280.554 79.8374 279.077C78.9847 277.599 79.4909 275.71 80.9683 274.857C82.1745 274.161 83.6553 274.37 84.6226 275.274L85.8384 274.572C84.5473 272.11 83.816 269.308 83.816 266.335C83.816 264.66 84.0479 263.04 84.481 261.504L83.1021 260.125C81.9538 260.673 80.5366 260.472 79.5855 259.521C78.3791 258.315 78.3791 256.359 79.5855 255.152C80.7919 253.946 82.7482 253.946 83.9546 255.152C84.9394 256.137 85.1197 257.621 84.4966 258.79L85.1871 259.48C87.7438 253.373 93.6142 248.998 100.55 248.601V247.881C99.3505 247.457 98.4908 246.312 98.4908 244.967C98.491 243.261 99.8738 241.878 101.58 241.878Z",
    fill: "white"
  }))), _g51 || (_g51 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter50_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M202.496 46.6066C201.097 41.3878 204.195 36.0236 209.413 34.6252V34.6252C214.632 33.2268 219.996 36.3239 221.395 41.5427L231.922 80.8323C233.321 86.051 230.224 91.4152 225.005 92.8136V92.8136C219.786 94.212 214.422 91.1149 213.023 85.8962L202.496 46.6066Z",
    fill: "white"
  }))), _rect73 || (_rect73 = /*#__PURE__*/React.createElement("rect", {
    x: 206.182,
    y: 50.4168,
    width: 14.4167,
    height: 45.8244,
    rx: 7.20833,
    transform: "rotate(-15 206.182 50.4168)",
    fill: "#E2E2E2"
  })), _rect74 || (_rect74 = /*#__PURE__*/React.createElement("rect", {
    x: 209.903,
    y: 56.3465,
    width: 10.2976,
    height: 39.131,
    rx: 5.14881,
    transform: "rotate(-15 209.903 56.3465)",
    fill: "white"
  })), _g52 || (_g52 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter51_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M181.171 61.674C178.469 56.995 180.072 51.012 184.751 48.3105V48.3105C189.43 45.6091 195.413 47.2123 198.115 51.8913L218.453 87.1174C221.154 91.7964 219.551 97.7794 214.872 100.481V100.481C210.193 103.182 204.21 101.579 201.508 96.9001L181.171 61.674Z",
    fill: "white"
  }))), _rect75 || (_rect75 = /*#__PURE__*/React.createElement("rect", {
    x: 185.717,
    y: 64.4011,
    width: 14.4167,
    height: 45.8244,
    rx: 7.20833,
    transform: "rotate(-30 185.717 64.4011)",
    fill: "#E2E2E2"
  })), _rect76 || (_rect76 = /*#__PURE__*/React.createElement("rect", {
    x: 190.848,
    y: 69.1667,
    width: 10.2976,
    height: 39.131,
    rx: 5.14881,
    transform: "rotate(-30 190.848 69.1667)",
    fill: "white"
  })), _g53 || (_g53 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter52_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M166.216 87.3941C161.537 84.6926 159.934 78.7096 162.636 74.0306V74.0306C165.337 69.3516 171.32 67.7484 175.999 70.4499L211.225 90.7877C215.904 93.4891 217.507 99.4721 214.806 104.151V104.151C212.104 108.83 206.121 110.433 201.442 107.732L166.216 87.3941Z",
    fill: "white"
  }))), _rect77 || (_rect77 = /*#__PURE__*/React.createElement("rect", {
    x: 171.517,
    y: 87.4812,
    width: 14.4167,
    height: 45.8244,
    rx: 7.20833,
    transform: "rotate(-60 171.517 87.4812)",
    fill: "#E2E2E2"
  })), _rect78 || (_rect78 = /*#__PURE__*/React.createElement("rect", {
    x: 178.343,
    y: 89.0457,
    width: 10.2976,
    height: 39.131,
    rx: 5.14881,
    transform: "rotate(-60 178.343 89.0457)",
    fill: "white"
  })), _g54 || (_g54 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter53_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M161.529 111.704C156.311 110.306 153.214 104.942 154.612 99.723V99.723C156.01 94.5042 161.375 91.4072 166.593 92.8055L205.883 103.333C211.102 104.732 214.199 110.096 212.8 115.315V115.315C211.402 120.533 206.038 123.63 200.819 122.232L161.529 111.704Z",
    fill: "white"
  }))), _rect79 || (_rect79 = /*#__PURE__*/React.createElement("rect", {
    x: 166.672,
    y: 110.419,
    width: 14.4167,
    height: 45.8244,
    rx: 7.20833,
    transform: "rotate(-75 166.672 110.419)",
    fill: "#E2E2E2"
  })), _rect80 || (_rect80 = /*#__PURE__*/React.createElement("rect", {
    x: 173.67,
    y: 110.159,
    width: 10.2976,
    height: 39.131,
    rx: 5.14881,
    transform: "rotate(-75 173.67 110.159)",
    fill: "white"
  })), _g55 || (_g55 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter54_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M170.197 140.767C164.979 142.166 159.614 139.069 158.216 133.85V133.85C156.818 128.631 159.915 123.267 165.134 121.869L204.423 111.341C209.642 109.943 215.006 113.04 216.404 118.258V118.258C217.803 123.477 214.706 128.841 209.487 130.24L170.197 140.767Z",
    fill: "white"
  }))), _rect81 || (_rect81 = /*#__PURE__*/React.createElement("rect", {
    x: 174.007,
    y: 137.081,
    width: 14.4167,
    height: 45.8244,
    rx: 7.20833,
    transform: "rotate(-105 174.007 137.081)",
    fill: "#E2E2E2"
  })), _rect82 || (_rect82 = /*#__PURE__*/React.createElement("rect", {
    x: 179.939,
    y: 133.36,
    width: 10.2976,
    height: 39.131,
    rx: 5.14881,
    transform: "rotate(-105 179.939 133.36)",
    fill: "white"
  })), _g56 || (_g56 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter55_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M176.513 164.885C171.834 167.586 165.851 165.983 163.15 161.304V161.304C160.448 156.625 162.051 150.642 166.73 147.941L201.956 127.603C206.635 124.901 212.619 126.504 215.32 131.183V131.183C218.021 135.862 216.418 141.846 211.739 144.547L176.513 164.885Z",
    fill: "white"
  }))), _rect83 || (_rect83 = /*#__PURE__*/React.createElement("rect", {
    x: 179.239,
    y: 160.339,
    width: 14.4167,
    height: 45.8244,
    rx: 7.20833,
    transform: "rotate(-120 179.239 160.339)",
    fill: "#E2E2E2"
  })), _rect84 || (_rect84 = /*#__PURE__*/React.createElement("rect", {
    x: 184.006,
    y: 155.206,
    width: 10.2976,
    height: 39.131,
    rx: 5.14881,
    transform: "rotate(-120 184.006 155.206)",
    fill: "white"
  })), _g57 || (_g57 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter56_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M200.689 184.431C197.988 189.11 192.005 190.713 187.326 188.012V188.012C182.647 185.31 181.044 179.327 183.745 174.648L204.083 139.422C206.784 134.743 212.767 133.14 217.446 135.842V135.842C222.125 138.543 223.728 144.526 221.027 149.205L200.689 184.431Z",
    fill: "white"
  }))), _rect85 || (_rect85 = /*#__PURE__*/React.createElement("rect", {
    x: 200.776,
    y: 179.132,
    width: 14.4167,
    height: 45.8244,
    rx: 7.20833,
    transform: "rotate(-150 200.776 179.132)",
    fill: "#E2E2E2"
  })), _rect86 || (_rect86 = /*#__PURE__*/React.createElement("rect", {
    x: 202.34,
    y: 172.303,
    width: 10.2976,
    height: 39.131,
    rx: 5.14881,
    transform: "rotate(-150 202.34 172.303)",
    fill: "white"
  })), _g58 || (_g58 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter57_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M222.425 194.02C221.026 199.239 215.662 202.336 210.443 200.938V200.938C205.224 199.539 202.127 194.175 203.526 188.956L214.053 149.667C215.452 144.448 220.816 141.351 226.035 142.749V142.749C231.253 144.147 234.351 149.512 232.952 154.73L222.425 194.02Z",
    fill: "white"
  }))), _rect87 || (_rect87 = /*#__PURE__*/React.createElement("rect", {
    x: 221.137,
    y: 188.876,
    width: 14.4167,
    height: 45.8244,
    rx: 7.20833,
    transform: "rotate(-165 221.137 188.876)",
    fill: "#E2E2E2"
  })), _rect88 || (_rect88 = /*#__PURE__*/React.createElement("rect", {
    x: 220.88,
    y: 181.878,
    width: 10.2976,
    height: 39.131,
    rx: 5.14881,
    transform: "rotate(-165 220.88 181.878)",
    fill: "white"
  })), _g59 || (_g59 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter58_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 248.363,
    y: 205.606,
    width: 19.5655,
    height: 60.2411,
    rx: 9.78274,
    transform: "rotate(180 248.363 205.606)",
    fill: "white"
  }))), _rect89 || (_rect89 = /*#__PURE__*/React.createElement("rect", {
    x: 245.789,
    y: 191.19,
    width: 14.4167,
    height: 45.8244,
    rx: 7.20833,
    transform: "rotate(180 245.789 191.19)",
    fill: "#E2E2E2"
  })), _rect90 || (_rect90 = /*#__PURE__*/React.createElement("rect", {
    x: 243.729,
    y: 184.497,
    width: 10.2976,
    height: 39.131,
    rx: 5.14881,
    transform: "rotate(180 243.729 184.497)",
    fill: "white"
  })), _g60 || (_g60 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter59_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M274.664 190.577C276.063 195.795 272.966 201.16 267.747 202.558V202.558C262.528 203.956 257.164 200.859 255.766 195.641L245.238 156.351C243.84 151.132 246.937 145.768 252.155 144.37V144.37C257.374 142.971 262.738 146.068 264.137 151.287L274.664 190.577Z",
    fill: "white"
  }))), _rect91 || (_rect91 = /*#__PURE__*/React.createElement("rect", {
    x: 270.979,
    y: 186.768,
    width: 14.4167,
    height: 45.8244,
    rx: 7.20833,
    transform: "rotate(165 270.979 186.768)",
    fill: "#E2E2E2"
  })), _rect92 || (_rect92 = /*#__PURE__*/React.createElement("rect", {
    x: 267.257,
    y: 180.837,
    width: 10.2976,
    height: 39.131,
    rx: 5.14881,
    transform: "rotate(165 267.257 180.837)",
    fill: "white"
  })), _g61 || (_g61 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter60_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M295.989 175.509C298.691 180.188 297.088 186.171 292.409 188.873V188.873C287.73 191.574 281.747 189.971 279.045 185.292L258.707 150.066C256.006 145.387 257.609 139.404 262.288 136.702V136.702C266.967 134.001 272.95 135.604 275.652 140.283L295.989 175.509Z",
    fill: "white"
  }))), _rect93 || (_rect93 = /*#__PURE__*/React.createElement("rect", {
    x: 291.443,
    y: 172.784,
    width: 14.4167,
    height: 45.8244,
    rx: 7.20833,
    transform: "rotate(150 291.443 172.784)",
    fill: "#E2E2E2"
  })), _rect94 || (_rect94 = /*#__PURE__*/React.createElement("rect", {
    x: 286.312,
    y: 168.016,
    width: 10.2976,
    height: 39.131,
    rx: 5.14881,
    transform: "rotate(150 286.312 168.016)",
    fill: "white"
  })), _g62 || (_g62 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter61_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M310.944 149.791C315.623 152.492 317.226 158.475 314.525 163.154V163.154C311.823 167.833 305.84 169.437 301.161 166.735L265.935 146.397C261.256 143.696 259.653 137.713 262.354 133.034V133.034C265.056 128.355 271.039 126.752 275.718 129.453L310.944 149.791Z",
    fill: "white"
  }))), _rect95 || (_rect95 = /*#__PURE__*/React.createElement("rect", {
    x: 305.644,
    y: 149.702,
    width: 14.4167,
    height: 45.8244,
    rx: 7.20833,
    transform: "rotate(120 305.644 149.702)",
    fill: "#E2E2E2"
  })), _rect96 || (_rect96 = /*#__PURE__*/React.createElement("rect", {
    x: 298.817,
    y: 148.139,
    width: 10.2976,
    height: 39.131,
    rx: 5.14881,
    transform: "rotate(120 298.817 148.139)",
    fill: "white"
  })), _g63 || (_g63 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter62_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M315.631 125.48C320.849 126.879 323.946 132.243 322.548 137.462V137.462C321.15 142.681 315.786 145.778 310.567 144.379L271.277 133.852C266.058 132.453 262.961 127.089 264.36 121.87V121.87C265.758 116.652 271.122 113.555 276.341 114.953L315.631 125.48Z",
    fill: "white"
  }))), _rect97 || (_rect97 = /*#__PURE__*/React.createElement("rect", {
    x: 310.488,
    y: 126.766,
    width: 14.4167,
    height: 45.8244,
    rx: 7.20833,
    transform: "rotate(105 310.488 126.766)",
    fill: "#E2E2E2"
  })), _rect98 || (_rect98 = /*#__PURE__*/React.createElement("rect", {
    x: 303.49,
    y: 127.024,
    width: 10.2976,
    height: 39.131,
    rx: 5.14881,
    transform: "rotate(105 303.49 127.024)",
    fill: "white"
  })), _g64 || (_g64 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter63_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M306.963 96.4175C312.181 95.0191 317.546 98.1161 318.944 103.335V103.335C320.342 108.554 317.245 113.918 312.027 115.316L272.737 125.844C267.518 127.242 262.154 124.145 260.756 118.926V118.926C259.357 113.708 262.454 108.343 267.673 106.945L306.963 96.4175Z",
    fill: "white"
  }))), _rect99 || (_rect99 = /*#__PURE__*/React.createElement("rect", {
    x: 303.152,
    y: 100.102,
    width: 14.4167,
    height: 45.8244,
    rx: 7.20833,
    transform: "rotate(75 303.152 100.102)",
    fill: "#E2E2E2"
  })), _rect100 || (_rect100 = /*#__PURE__*/React.createElement("rect", {
    x: 297.221,
    y: 103.825,
    width: 10.2976,
    height: 39.131,
    rx: 5.14881,
    transform: "rotate(75 297.221 103.825)",
    fill: "white"
  })), _g65 || (_g65 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter64_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M300.647 72.3003C305.326 69.5989 311.309 71.202 314.011 75.881V75.881C316.712 80.56 315.109 86.5431 310.43 89.2445L275.204 109.582C270.525 112.284 264.542 110.681 261.84 106.002V106.002C259.139 101.323 260.742 95.3395 265.421 92.6381L300.647 72.3003Z",
    fill: "white"
  }))), _rect101 || (_rect101 = /*#__PURE__*/React.createElement("rect", {
    x: 297.921,
    y: 76.8464,
    width: 14.4167,
    height: 45.8244,
    rx: 7.20833,
    transform: "rotate(60 297.921 76.8464)",
    fill: "#E2E2E2"
  })), _rect102 || (_rect102 = /*#__PURE__*/React.createElement("rect", {
    x: 293.154,
    y: 81.9773,
    width: 10.2976,
    height: 39.131,
    rx: 5.14881,
    transform: "rotate(60 293.154 81.9773)",
    fill: "white"
  })), _g66 || (_g66 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter65_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M276.471 52.7521C279.172 48.0731 285.155 46.47 289.834 49.1714V49.1714C294.513 51.8728 296.117 57.8559 293.415 62.5349L273.077 97.761C270.376 102.44 264.393 104.043 259.714 101.342V101.342C255.035 98.6403 253.432 92.6572 256.133 87.9782L276.471 52.7521Z",
    fill: "white"
  }))), _rect103 || (_rect103 = /*#__PURE__*/React.createElement("rect", {
    x: 276.383,
    y: 58.0533,
    width: 14.4167,
    height: 45.8244,
    rx: 7.20833,
    transform: "rotate(30 276.383 58.0533)",
    fill: "#E2E2E2"
  })), _rect104 || (_rect104 = /*#__PURE__*/React.createElement("rect", {
    x: 274.82,
    y: 64.8816,
    width: 10.2976,
    height: 39.131,
    rx: 5.14881,
    transform: "rotate(30 274.82 64.8816)",
    fill: "white"
  })), _g67 || (_g67 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter66_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M254.736 43.165C256.134 37.9462 261.498 34.8492 266.717 36.2475V36.2475C271.936 37.6459 275.033 43.0101 273.634 48.2289L263.107 87.5185C261.708 92.7373 256.344 95.8343 251.125 94.4359V94.4359C245.907 93.0376 242.81 87.6733 244.208 82.4546L254.736 43.165Z",
    fill: "white"
  }))), _rect105 || (_rect105 = /*#__PURE__*/React.createElement("rect", {
    x: 256.022,
    y: 48.3075,
    width: 14.4167,
    height: 45.8244,
    rx: 7.20833,
    transform: "rotate(15 256.022 48.3075)",
    fill: "#E2E2E2"
  })), _rect106 || (_rect106 = /*#__PURE__*/React.createElement("rect", {
    x: 256.28,
    y: 55.3055,
    width: 10.2976,
    height: 39.131,
    rx: 5.14881,
    transform: "rotate(15 256.28 55.3055)",
    fill: "white"
  })), _g68 || (_g68 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter67_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M228.798 41.3596C228.798 35.9568 233.178 31.5769 238.581 31.5769V31.5769C243.983 31.5769 248.363 35.9568 248.363 41.3596L248.363 82.0352C248.363 87.4381 243.983 91.818 238.581 91.818V91.818C233.178 91.818 228.798 87.4381 228.798 82.0352L228.798 41.3596Z",
    fill: "white"
  }))), _rect107 || (_rect107 = /*#__PURE__*/React.createElement("rect", {
    x: 231.372,
    y: 45.9929,
    width: 14.4167,
    height: 45.8244,
    rx: 7.20833,
    fill: "#E2E2E2"
  })), _rect108 || (_rect108 = /*#__PURE__*/React.createElement("rect", {
    x: 233.432,
    y: 52.6863,
    width: 10.2976,
    height: 39.131,
    rx: 5.14881,
    fill: "white"
  })), _g69 || (_g69 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter68_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 253.511,
    y: 168.536,
    width: 29.8631,
    height: 54.0625,
    rx: 14.9315,
    transform: "rotate(180 253.511 168.536)",
    fill: "#F4D5AD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248.362,
    y: 154.118,
    width: 19.5655,
    height: 35.5268,
    rx: 9.78274,
    transform: "rotate(180 248.362 154.118)",
    fill: "#F4C283"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244.758,
    y: 145.366,
    width: 12.3571,
    height: 22.1399,
    rx: 6.17857,
    transform: "rotate(180 244.758 145.366)",
    fill: "#F4D5AD"
  }))), _g70 || (_g70 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter69_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 187.607,
    y: 99.5477,
    width: 29.8631,
    height: 54.0625,
    rx: 14.9315,
    transform: "rotate(-45 187.607 99.5477)",
    fill: "#F4D5AD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 201.442,
    y: 106.102,
    width: 19.5655,
    height: 35.5268,
    rx: 9.78274,
    transform: "rotate(-45 201.442 106.102)",
    fill: "#F4C283"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210.18,
    y: 109.743,
    width: 12.3571,
    height: 22.1399,
    rx: 6.17857,
    transform: "rotate(-45 210.18 109.743)",
    fill: "#F4D5AD"
  }))), _g71 || (_g71 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter70_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 202.538,
    y: 156.553,
    width: 29.8631,
    height: 54.0625,
    rx: 14.9315,
    transform: "rotate(-120 202.538 156.553)",
    fill: "#F4D5AD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212.448,
    y: 144.886,
    width: 19.5655,
    height: 35.5268,
    rx: 9.78274,
    transform: "rotate(-120 212.448 144.886)",
    fill: "#F4C283"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218.227,
    y: 137.388,
    width: 12.3571,
    height: 22.1399,
    rx: 6.17857,
    transform: "rotate(-120 218.227 137.388)",
    fill: "#F4D5AD"
  }))), _g72 || (_g72 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter71_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 290.034,
    y: 139.042,
    width: 29.8631,
    height: 54.0625,
    rx: 14.9315,
    transform: "rotate(135 290.034 139.042)",
    fill: "#F4D5AD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276.199,
    y: 132.487,
    width: 19.5655,
    height: 35.5268,
    rx: 9.78274,
    transform: "rotate(135 276.199 132.487)",
    fill: "#F4C283"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 267.461,
    y: 128.849,
    width: 12.3571,
    height: 22.1399,
    rx: 6.17857,
    transform: "rotate(135 267.461 128.849)",
    fill: "#F4D5AD"
  }))), _g73 || (_g73 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter72_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 275.102,
    y: 82.036,
    width: 29.8631,
    height: 54.0625,
    rx: 14.9315,
    transform: "rotate(60 275.102 82.036)",
    fill: "#F4D5AD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265.19,
    y: 93.7021,
    width: 19.5655,
    height: 35.5268,
    rx: 9.78274,
    transform: "rotate(60 265.19 93.7021)",
    fill: "#F4C283"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 259.412,
    y: 101.2,
    width: 12.3571,
    height: 22.1399,
    rx: 6.17857,
    transform: "rotate(60 259.412 101.2)",
    fill: "#F4D5AD"
  }))), _g74 || (_g74 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter73_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 223.648,
    y: 68.134,
    width: 29.8631,
    height: 54.0625,
    rx: 14.9315,
    fill: "#F4D5AD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228.797,
    y: 82.5499,
    width: 19.5655,
    height: 35.5268,
    rx: 9.78274,
    fill: "#F4C283"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 232.4,
    y: 91.3038,
    width: 12.3571,
    height: 22.1399,
    rx: 6.17857,
    fill: "#F4D5AD"
  }))), _g75 || (_g75 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter74_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M238.58 93.8777C240.286 93.8777 241.668 95.2606 241.668 96.9666C241.668 98.3594 240.747 99.5371 239.48 99.9226V100.594C245.925 100.915 251.464 104.673 254.306 110.072L255.088 109.622C254.856 108.371 255.417 107.054 256.581 106.382C258.059 105.529 259.948 106.035 260.801 107.512C261.654 108.99 261.148 110.879 259.67 111.732C258.464 112.428 256.983 112.219 256.016 111.315L255.116 111.835C255.908 113.848 256.342 116.041 256.342 118.335C256.342 120.411 255.984 122.404 255.33 124.257L257.538 126.465C258.686 125.916 260.103 126.117 261.054 127.068C262.26 128.275 262.26 130.231 261.054 131.437C259.848 132.644 257.891 132.644 256.685 131.437C255.7 130.452 255.519 128.968 256.142 127.8L254.52 126.177C251.766 131.763 246.165 135.692 239.61 136.067V137.302C240.809 137.727 241.668 138.872 241.668 140.217C241.668 141.923 240.286 143.305 238.58 143.305C236.874 143.305 235.491 141.923 235.491 140.217C235.491 138.824 236.412 137.646 237.679 137.26V136.075C231.906 135.787 226.858 132.742 223.826 128.23L222.55 128.968C222.783 130.219 222.222 131.535 221.057 132.208C219.579 133.061 217.69 132.554 216.837 131.077C215.984 129.599 216.491 127.71 217.968 126.857C219.174 126.161 220.655 126.37 221.622 127.274L222.838 126.572C221.547 124.11 220.816 121.308 220.816 118.335C220.816 116.66 221.047 115.04 221.48 113.504L220.101 112.125C218.953 112.673 217.535 112.472 216.584 111.521C215.378 110.315 215.378 108.359 216.584 107.152C217.791 105.946 219.747 105.946 220.954 107.152C221.938 108.137 222.12 109.621 221.497 110.79L222.186 111.479C224.743 105.372 230.614 100.998 237.549 100.601V99.8806C236.35 99.4564 235.49 98.3115 235.49 96.9666C235.49 95.2606 236.873 93.8777 238.58 93.8777Z",
    fill: "white"
  }))), _g76 || (_g76 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter75_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M237.318 202.559C235.842 197.048 239.112 191.384 244.623 189.907V189.907C250.134 188.43 255.799 191.701 257.275 197.212L268.392 238.701C269.869 244.212 266.598 249.877 261.088 251.353V251.353C255.577 252.83 249.912 249.56 248.435 244.049L237.318 202.559Z",
    fill: "#EA8998"
  }))), _rect109 || (_rect109 = /*#__PURE__*/React.createElement("rect", {
    x: 241.211,
    y: 206.583,
    width: 15.2239,
    height: 48.3901,
    rx: 7.61193,
    transform: "rotate(-15 241.211 206.583)",
    fill: "#E1798C"
  })), _rect110 || (_rect110 = /*#__PURE__*/React.createElement("rect", {
    x: 245.141,
    y: 212.846,
    width: 10.8742,
    height: 41.3219,
    rx: 5.4371,
    transform: "rotate(-15 245.141 212.846)",
    fill: "#EA8998"
  })), _g77 || (_g77 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter76_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M214.8 218.472C211.947 213.531 213.64 207.213 218.581 204.36V204.36C223.522 201.508 229.84 203.201 232.693 208.142L254.169 245.34C257.022 250.281 255.329 256.599 250.388 259.452V259.452C245.447 262.304 239.129 260.612 236.277 255.671L214.8 218.472Z",
    fill: "#EA8998"
  }))), _rect111 || (_rect111 = /*#__PURE__*/React.createElement("rect", {
    x: 219.601,
    y: 221.35,
    width: 15.2239,
    height: 48.3901,
    rx: 7.61193,
    transform: "rotate(-30 219.601 221.35)",
    fill: "#E1798C"
  })), _rect112 || (_rect112 = /*#__PURE__*/React.createElement("rect", {
    x: 225.018,
    y: 226.383,
    width: 10.8742,
    height: 41.3219,
    rx: 5.4371,
    transform: "rotate(-30 225.018 226.383)",
    fill: "#EA8998"
  })), _g78 || (_g78 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter77_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M199.007 245.633C194.066 242.78 192.373 236.462 195.226 231.521V231.521C198.078 226.58 204.396 224.887 209.337 227.74L246.536 249.216C251.477 252.069 253.17 258.387 250.317 263.328V263.328C247.464 268.269 241.146 269.962 236.205 267.109L199.007 245.633Z",
    fill: "#EA8998"
  }))), _rect113 || (_rect113 = /*#__PURE__*/React.createElement("rect", {
    x: 204.604,
    y: 245.725,
    width: 15.2239,
    height: 48.3901,
    rx: 7.61193,
    transform: "rotate(-60 204.604 245.725)",
    fill: "#E1798C"
  })), _rect114 || (_rect114 = /*#__PURE__*/React.createElement("rect", {
    x: 211.812,
    y: 247.376,
    width: 10.8742,
    height: 41.3219,
    rx: 5.4371,
    transform: "rotate(-60 211.812 247.376)",
    fill: "#EA8998"
  })), _g79 || (_g79 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter78_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M194.059 271.303C188.548 269.827 185.277 264.162 186.754 258.651V258.651C188.23 253.14 193.895 249.87 199.406 251.346L240.895 262.463C246.406 263.94 249.677 269.605 248.2 275.116V275.116C246.724 280.627 241.059 283.897 235.548 282.42L194.059 271.303Z",
    fill: "#EA8998"
  }))), _rect115 || (_rect115 = /*#__PURE__*/React.createElement("rect", {
    x: 199.489,
    y: 269.944,
    width: 15.2239,
    height: 48.3901,
    rx: 7.61193,
    transform: "rotate(-75 199.489 269.944)",
    fill: "#E1798C"
  })), _rect116 || (_rect116 = /*#__PURE__*/React.createElement("rect", {
    x: 206.88,
    y: 269.673,
    width: 10.8742,
    height: 41.3219,
    rx: 5.4371,
    transform: "rotate(-75 206.88 269.673)",
    fill: "#EA8998"
  })), _g80 || (_g80 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter79_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M203.212 301.993C197.701 303.47 192.036 300.199 190.56 294.688V294.688C189.083 289.177 192.353 283.513 197.864 282.036L239.354 270.919C244.865 269.442 250.529 272.713 252.006 278.224V278.224C253.483 283.735 250.212 289.399 244.701 290.876L203.212 301.993Z",
    fill: "#EA8998"
  }))), _rect117 || (_rect117 = /*#__PURE__*/React.createElement("rect", {
    x: 207.234,
    y: 298.102,
    width: 15.2239,
    height: 48.3901,
    rx: 7.61193,
    transform: "rotate(-105 207.234 298.102)",
    fill: "#E1798C"
  })), _rect118 || (_rect118 = /*#__PURE__*/React.createElement("rect", {
    x: 213.499,
    y: 294.171,
    width: 10.8742,
    height: 41.3219,
    rx: 5.4371,
    transform: "rotate(-105 213.499 294.171)",
    fill: "#EA8998"
  })), _g81 || (_g81 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter80_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M209.882 327.46C204.941 330.313 198.623 328.62 195.77 323.679V323.679C192.918 318.738 194.611 312.42 199.552 309.568L236.75 288.091C241.691 285.238 248.009 286.931 250.862 291.872V291.872C253.714 296.813 252.021 303.131 247.08 305.984L209.882 327.46Z",
    fill: "#EA8998"
  }))), _rect119 || (_rect119 = /*#__PURE__*/React.createElement("rect", {
    x: 212.761,
    y: 322.659,
    width: 15.2239,
    height: 48.3901,
    rx: 7.61193,
    transform: "rotate(-120 212.761 322.659)",
    fill: "#E1798C"
  })), _rect120 || (_rect120 = /*#__PURE__*/React.createElement("rect", {
    x: 217.794,
    y: 317.241,
    width: 10.8742,
    height: 41.3219,
    rx: 5.4371,
    transform: "rotate(-120 217.794 317.241)",
    fill: "#EA8998"
  })), _g82 || (_g82 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter81_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M235.411 348.103C232.559 353.044 226.241 354.737 221.3 351.884V351.884C216.359 349.032 214.666 342.714 217.518 337.773L238.995 300.574C241.848 295.633 248.166 293.94 253.107 296.793V296.793C258.048 299.646 259.741 305.964 256.888 310.905L235.411 348.103Z",
    fill: "#EA8998"
  }))), _rect121 || (_rect121 = /*#__PURE__*/React.createElement("rect", {
    x: 235.504,
    y: 342.507,
    width: 15.2239,
    height: 48.3901,
    rx: 7.61193,
    transform: "rotate(-150 235.504 342.507)",
    fill: "#E1798C"
  })), _rect122 || (_rect122 = /*#__PURE__*/React.createElement("rect", {
    x: 237.154,
    y: 335.296,
    width: 10.8742,
    height: 41.3219,
    rx: 5.4371,
    transform: "rotate(-150 237.154 335.296)",
    fill: "#EA8998"
  })), _g83 || (_g83 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter82_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M258.363 358.227C256.887 363.738 251.222 367.009 245.711 365.532V365.532C240.2 364.055 236.93 358.391 238.406 352.88L249.523 311.39C251 305.879 256.665 302.609 262.175 304.086V304.086C267.686 305.562 270.957 311.227 269.48 316.738L258.363 358.227Z",
    fill: "#EA8998"
  }))), _rect123 || (_rect123 = /*#__PURE__*/React.createElement("rect", {
    x: 257.004,
    y: 352.798,
    width: 15.2239,
    height: 48.3901,
    rx: 7.61193,
    transform: "rotate(-165 257.004 352.798)",
    fill: "#E1798C"
  })), _rect124 || (_rect124 = /*#__PURE__*/React.createElement("rect", {
    x: 256.732,
    y: 345.409,
    width: 10.8742,
    height: 41.3219,
    rx: 5.4371,
    transform: "rotate(-165 256.732 345.409)",
    fill: "#EA8998"
  })), _g84 || (_g84 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter83_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 285.754,
    y: 370.464,
    width: 20.661,
    height: 63.614,
    rx: 10.3305,
    transform: "rotate(180 285.754 370.464)",
    fill: "#EA8998"
  }))), _rect125 || (_rect125 = /*#__PURE__*/React.createElement("rect", {
    x: 283.035,
    y: 355.239,
    width: 15.2239,
    height: 48.3901,
    rx: 7.61193,
    transform: "rotate(180 283.035 355.239)",
    fill: "#E1798C"
  })), _rect126 || (_rect126 = /*#__PURE__*/React.createElement("rect", {
    x: 280.86,
    y: 348.171,
    width: 10.8742,
    height: 41.3219,
    rx: 5.4371,
    transform: "rotate(180 280.86 348.171)",
    fill: "#EA8998"
  })), _g85 || (_g85 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter84_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M313.527 354.595C315.004 360.105 311.734 365.77 306.223 367.247V367.247C300.712 368.723 295.047 365.453 293.57 359.942L282.453 318.453C280.977 312.942 284.247 307.277 289.758 305.8V305.8C295.269 304.324 300.934 307.594 302.41 313.105L313.527 354.595Z",
    fill: "#EA8998"
  }))), _rect127 || (_rect127 = /*#__PURE__*/React.createElement("rect", {
    x: 309.635,
    y: 350.571,
    width: 15.2239,
    height: 48.3901,
    rx: 7.61193,
    transform: "rotate(165 309.635 350.571)",
    fill: "#E1798C"
  })), _rect128 || (_rect128 = /*#__PURE__*/React.createElement("rect", {
    x: 305.705,
    y: 344.307,
    width: 10.8742,
    height: 41.3219,
    rx: 5.4371,
    transform: "rotate(165 305.705 344.307)",
    fill: "#EA8998"
  })), _g86 || (_g86 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter85_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M336.047 338.682C338.899 343.623 337.206 349.941 332.265 352.793V352.793C327.324 355.646 321.006 353.953 318.154 349.012L296.677 311.814C293.825 306.873 295.517 300.555 300.458 297.702V297.702C305.399 294.849 311.717 296.542 314.57 301.483L336.047 338.682Z",
    fill: "#EA8998"
  }))), _rect129 || (_rect129 = /*#__PURE__*/React.createElement("rect", {
    x: 331.246,
    y: 335.804,
    width: 15.2239,
    height: 48.3901,
    rx: 7.61193,
    transform: "rotate(150 331.246 335.804)",
    fill: "#E1798C"
  })), _rect130 || (_rect130 = /*#__PURE__*/React.createElement("rect", {
    x: 325.829,
    y: 330.77,
    width: 10.8742,
    height: 41.3219,
    rx: 5.4371,
    transform: "rotate(150 325.829 330.77)",
    fill: "#EA8998"
  })), _g87 || (_g87 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter86_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M351.839 311.521C356.78 314.374 358.473 320.692 355.62 325.633V325.633C352.767 330.574 346.449 332.267 341.508 329.414L304.31 307.937C299.369 305.085 297.676 298.767 300.529 293.826V293.826C303.381 288.885 309.699 287.192 314.64 290.045L351.839 311.521Z",
    fill: "#EA8998"
  }))), _rect131 || (_rect131 = /*#__PURE__*/React.createElement("rect", {
    x: 346.242,
    y: 311.428,
    width: 15.2239,
    height: 48.3901,
    rx: 7.61193,
    transform: "rotate(120 346.242 311.428)",
    fill: "#E1798C"
  })), _rect132 || (_rect132 = /*#__PURE__*/React.createElement("rect", {
    x: 339.033,
    y: 309.778,
    width: 10.8742,
    height: 41.3219,
    rx: 5.4371,
    transform: "rotate(120 339.033 309.778)",
    fill: "#EA8998"
  })), _g88 || (_g88 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter87_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M356.788 285.85C362.299 287.327 365.57 292.992 364.093 298.503V298.503C362.616 304.014 356.952 307.284 351.441 305.807L309.951 294.69C304.44 293.214 301.17 287.549 302.646 282.038V282.038C304.123 276.527 309.788 273.257 315.299 274.733L356.788 285.85Z",
    fill: "#EA8998"
  }))), _rect133 || (_rect133 = /*#__PURE__*/React.createElement("rect", {
    x: 351.358,
    y: 287.21,
    width: 15.2239,
    height: 48.3901,
    rx: 7.61193,
    transform: "rotate(105 351.358 287.21)",
    fill: "#E1798C"
  })), _rect134 || (_rect134 = /*#__PURE__*/React.createElement("rect", {
    x: 343.968,
    y: 287.481,
    width: 10.8742,
    height: 41.3219,
    rx: 5.4371,
    transform: "rotate(105 343.968 287.481)",
    fill: "#EA8998"
  })), _g89 || (_g89 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter88_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M347.635 255.161C353.146 253.684 358.81 256.955 360.287 262.466V262.466C361.764 267.976 358.493 273.641 352.982 275.118L311.493 286.235C305.982 287.711 300.317 284.441 298.841 278.93V278.93C297.364 273.419 300.634 267.755 306.145 266.278L347.635 255.161Z",
    fill: "#EA8998"
  }))), _rect135 || (_rect135 = /*#__PURE__*/React.createElement("rect", {
    x: 343.612,
    y: 259.052,
    width: 15.2239,
    height: 48.3901,
    rx: 7.61193,
    transform: "rotate(75 343.612 259.052)",
    fill: "#E1798C"
  })), _rect136 || (_rect136 = /*#__PURE__*/React.createElement("rect", {
    x: 337.347,
    y: 262.983,
    width: 10.8742,
    height: 41.3219,
    rx: 5.4371,
    transform: "rotate(75 337.347 262.983)",
    fill: "#EA8998"
  })), _g90 || (_g90 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter89_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M340.966 229.693C345.907 226.841 352.225 228.534 355.077 233.475V233.475C357.93 238.416 356.237 244.734 351.296 247.586L314.098 269.063C309.157 271.915 302.839 270.223 299.986 265.282V265.282C297.133 260.341 298.826 254.023 303.767 251.17L340.966 229.693Z",
    fill: "#EA8998"
  }))), _rect137 || (_rect137 = /*#__PURE__*/React.createElement("rect", {
    x: 338.087,
    y: 234.495,
    width: 15.2239,
    height: 48.3901,
    rx: 7.61193,
    transform: "rotate(60 338.087 234.495)",
    fill: "#E1798C"
  })), _rect138 || (_rect138 = /*#__PURE__*/React.createElement("rect", {
    x: 333.053,
    y: 239.913,
    width: 10.8742,
    height: 41.3219,
    rx: 5.4371,
    transform: "rotate(60 333.053 239.913)",
    fill: "#EA8998"
  })), _g91 || (_g91 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter90_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M315.435 209.051C318.288 204.11 324.606 202.417 329.547 205.269V205.269C334.488 208.122 336.181 214.44 333.328 219.381L311.852 256.58C308.999 261.521 302.681 263.214 297.74 260.361V260.361C292.799 257.508 291.106 251.19 293.959 246.249L315.435 209.051Z",
    fill: "#EA8998"
  }))), _rect139 || (_rect139 = /*#__PURE__*/React.createElement("rect", {
    x: 315.343,
    y: 214.647,
    width: 15.2239,
    height: 48.3901,
    rx: 7.61193,
    transform: "rotate(30 315.343 214.647)",
    fill: "#E1798C"
  })), _rect140 || (_rect140 = /*#__PURE__*/React.createElement("rect", {
    x: 313.692,
    y: 221.858,
    width: 10.8742,
    height: 41.3219,
    rx: 5.4371,
    transform: "rotate(30 313.692 221.858)",
    fill: "#EA8998"
  })), _g92 || (_g92 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter91_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M292.483 198.926C293.96 193.416 299.625 190.145 305.136 191.622V191.622C310.647 193.098 313.917 198.763 312.44 204.274L301.323 245.763C299.847 251.274 294.182 254.545 288.671 253.068V253.068C283.16 251.591 279.89 245.927 281.366 240.416L292.483 198.926Z",
    fill: "#EA8998"
  }))), _rect141 || (_rect141 = /*#__PURE__*/React.createElement("rect", {
    x: 293.843,
    y: 204.356,
    width: 15.2239,
    height: 48.3901,
    rx: 7.61193,
    transform: "rotate(15 293.843 204.356)",
    fill: "#E1798C"
  })), _rect142 || (_rect142 = /*#__PURE__*/React.createElement("rect", {
    x: 294.114,
    y: 211.745,
    width: 10.8742,
    height: 41.3219,
    rx: 5.4371,
    transform: "rotate(15 294.114 211.745)",
    fill: "#EA8998"
  })), _g93 || (_g93 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter92_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M265.093 197.02C265.093 191.315 269.718 186.69 275.423 186.69V186.69C281.129 186.69 285.754 191.315 285.754 197.02L285.754 239.973C285.754 245.679 281.129 250.304 275.423 250.304V250.304C269.718 250.304 265.093 245.679 265.093 239.973L265.093 197.02Z",
    fill: "#EA8998"
  }))), _rect143 || (_rect143 = /*#__PURE__*/React.createElement("rect", {
    x: 267.812,
    y: 201.915,
    width: 15.2239,
    height: 48.3901,
    rx: 7.61193,
    fill: "#E1798C"
  })), _rect144 || (_rect144 = /*#__PURE__*/React.createElement("rect", {
    x: 269.986,
    y: 208.983,
    width: 10.8742,
    height: 41.3219,
    rx: 5.4371,
    fill: "#EA8998"
  })), _g94 || (_g94 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter93_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 291.191,
    y: 331.317,
    width: 31.5351,
    height: 57.0895,
    rx: 15.7676,
    transform: "rotate(180 291.191 331.317)",
    fill: "#F4D5AD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285.755,
    y: 316.094,
    width: 20.661,
    height: 37.516,
    rx: 10.3305,
    transform: "rotate(180 285.755 316.094)",
    fill: "#F4C283"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 281.948,
    y: 306.85,
    width: 13.049,
    height: 23.3795,
    rx: 6.52451,
    transform: "rotate(180 281.948 306.85)",
    fill: "#F4D5AD"
  }))), _g95 || (_g95 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter94_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 221.596,
    y: 258.466,
    width: 31.5351,
    height: 57.0895,
    rx: 15.7676,
    transform: "rotate(-45 221.596 258.466)",
    fill: "#F4D5AD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236.205,
    y: 265.387,
    width: 20.661,
    height: 37.516,
    rx: 10.3305,
    transform: "rotate(-45 236.205 265.387)",
    fill: "#F4C283"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245.432,
    y: 269.229,
    width: 13.049,
    height: 23.3795,
    rx: 6.52451,
    transform: "rotate(-45 245.432 269.229)",
    fill: "#F4D5AD"
  }))), _g96 || (_g96 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter95_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 237.363,
    y: 318.665,
    width: 31.5351,
    height: 57.0895,
    rx: 15.7676,
    transform: "rotate(-120 237.363 318.665)",
    fill: "#F4D5AD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 247.829,
    y: 306.342,
    width: 20.661,
    height: 37.516,
    rx: 10.3305,
    transform: "rotate(-120 247.829 306.342)",
    fill: "#F4C283"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253.932,
    y: 298.425,
    width: 13.049,
    height: 23.3795,
    rx: 6.52451,
    transform: "rotate(-120 253.932 298.425)",
    fill: "#F4D5AD"
  }))), _g97 || (_g97 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter96_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 329.758,
    y: 300.171,
    width: 31.5351,
    height: 57.0895,
    rx: 15.7676,
    transform: "rotate(135 329.758 300.171)",
    fill: "#F4D5AD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 315.147,
    y: 293.251,
    width: 20.661,
    height: 37.516,
    rx: 10.3305,
    transform: "rotate(135 315.147 293.251)",
    fill: "#F4C283"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 305.921,
    y: 289.407,
    width: 13.049,
    height: 23.3795,
    rx: 6.52451,
    transform: "rotate(135 305.921 289.407)",
    fill: "#F4D5AD"
  }))), _g98 || (_g98 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter97_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 313.99,
    y: 239.974,
    width: 31.5351,
    height: 57.0895,
    rx: 15.7676,
    transform: "rotate(60 313.99 239.974)",
    fill: "#F4D5AD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 303.524,
    y: 252.294,
    width: 20.661,
    height: 37.516,
    rx: 10.3305,
    transform: "rotate(60 303.524 252.294)",
    fill: "#F4C283"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 297.423,
    y: 260.211,
    width: 13.049,
    height: 23.3795,
    rx: 6.52451,
    transform: "rotate(60 297.423 260.211)",
    fill: "#F4D5AD"
  }))), _g99 || (_g99 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter98_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 259.656,
    y: 225.294,
    width: 31.5351,
    height: 57.0895,
    rx: 15.7676,
    fill: "#F4D5AD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265.094,
    y: 240.516,
    width: 20.661,
    height: 37.516,
    rx: 10.3305,
    fill: "#F4C283"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268.899,
    y: 249.76,
    width: 13.049,
    height: 23.3795,
    rx: 6.52451,
    fill: "#F4D5AD"
  }))), _g100 || (_g100 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter99_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M275.423 252.481C277.225 252.481 278.686 253.942 278.686 255.744C278.685 257.215 277.712 258.458 276.374 258.865V259.573C283.18 259.913 289.028 263.881 292.029 269.581L292.856 269.104C292.61 267.783 293.203 266.393 294.433 265.682C295.993 264.782 297.989 265.316 298.89 266.877C299.79 268.437 299.256 270.432 297.695 271.333C296.422 272.068 294.858 271.847 293.836 270.892L292.884 271.441C293.721 273.568 294.182 275.884 294.182 278.307C294.182 280.5 293.803 282.605 293.111 284.561L295.443 286.892C296.655 286.313 298.152 286.526 299.156 287.53C300.43 288.804 300.43 290.869 299.156 292.143C297.882 293.417 295.816 293.417 294.542 292.143C293.502 291.103 293.312 289.536 293.97 288.302L292.257 286.59C289.349 292.489 283.433 296.637 276.511 297.033V298.338C277.778 298.785 278.686 299.994 278.686 301.414C278.686 303.216 277.225 304.677 275.423 304.677C273.621 304.676 272.161 303.215 272.161 301.414C272.161 299.943 273.134 298.7 274.472 298.293V297.041C268.375 296.736 263.045 293.522 259.843 288.757L258.498 289.534C258.744 290.855 258.151 292.246 256.921 292.956C255.361 293.857 253.366 293.322 252.465 291.761C251.564 290.201 252.098 288.206 253.658 287.305C254.932 286.57 256.496 286.791 257.518 287.746L258.801 287.005C257.438 284.405 256.665 281.446 256.665 278.307C256.665 276.539 256.911 274.827 257.368 273.205L255.911 271.748C254.699 272.327 253.202 272.114 252.197 271.11C250.924 269.836 250.924 267.771 252.197 266.497C253.471 265.223 255.538 265.223 256.812 266.497C257.851 267.537 258.042 269.104 257.384 270.338L258.113 271.067C260.814 264.619 267.013 259.999 274.336 259.581V258.82C273.069 258.372 272.161 257.164 272.161 255.744C272.161 253.942 273.621 252.481 275.423 252.481Z",
    fill: "#E78999"
  }))), _g101 || (_g101 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter100_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M322.432 30.5575C320.314 22.6539 325.005 14.5301 332.908 12.4123V12.4123C340.812 10.2946 348.936 14.9849 351.053 22.8884L366.997 82.3905C369.115 90.2941 364.424 98.4179 356.521 100.536V100.536C348.617 102.653 340.493 97.9631 338.376 90.0596L322.432 30.5575Z",
    fill: "#82E9CF"
  }))), _rect145 || (_rect145 = /*#__PURE__*/React.createElement("rect", {
    x: 328.015,
    y: 36.3269,
    width: 21.8333,
    height: 69.3987,
    rx: 10.9167,
    transform: "rotate(-15 328.015 36.3269)",
    fill: "#72D3B8"
  })), _rect146 || (_rect146 = /*#__PURE__*/React.createElement("rect", {
    x: 333.65,
    y: 45.3113,
    width: 15.5952,
    height: 59.2618,
    rx: 7.79761,
    transform: "rotate(-15 333.65 45.3113)",
    fill: "#82E9CF"
  })), _g102 || (_g102 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter101_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M290.136 53.3782C286.045 46.2921 288.473 37.2311 295.559 33.1399V33.1399C302.645 29.0487 311.706 31.4766 315.797 38.5627L346.598 91.9108C350.689 98.997 348.261 108.058 341.175 112.149V112.149C334.089 116.24 325.028 113.812 320.937 106.726L290.136 53.3782Z",
    fill: "#82E9CF"
  }))), _rect147 || (_rect147 = /*#__PURE__*/React.createElement("rect", {
    x: 297.021,
    y: 57.5065,
    width: 21.8333,
    height: 69.3987,
    rx: 10.9167,
    transform: "rotate(-30 297.021 57.5065)",
    fill: "#72D3B8"
  })), _rect148 || (_rect148 = /*#__PURE__*/React.createElement("rect", {
    x: 304.791,
    y: 64.7273,
    width: 15.5952,
    height: 59.2618,
    rx: 7.79761,
    transform: "rotate(-30 304.791 64.7273)",
    fill: "#82E9CF"
  })), _g103 || (_g103 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter102_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M267.489 92.3303C260.403 88.2392 257.975 79.1782 262.066 72.092V72.092C266.157 65.0059 275.218 62.578 282.304 66.6692L335.652 97.4698C342.738 101.561 345.166 110.622 341.075 117.708V117.708C336.984 124.794 327.923 127.222 320.837 123.131L267.489 92.3303Z",
    fill: "#82E9CF"
  }))), _rect149 || (_rect149 = /*#__PURE__*/React.createElement("rect", {
    x: 275.516,
    y: 92.4617,
    width: 21.8333,
    height: 69.3987,
    rx: 10.9167,
    transform: "rotate(-60 275.516 92.4617)",
    fill: "#72D3B8"
  })), _rect150 || (_rect150 = /*#__PURE__*/React.createElement("rect", {
    x: 285.854,
    y: 94.8289,
    width: 15.5952,
    height: 59.2618,
    rx: 7.79761,
    transform: "rotate(-60 285.854 94.8289)",
    fill: "#82E9CF"
  })), _g104 || (_g104 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter103_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M260.391 129.146C252.487 127.028 247.797 118.904 249.915 111.001V111.001C252.032 103.097 260.156 98.4068 268.06 100.525L327.562 116.468C335.465 118.586 340.156 126.71 338.038 134.613V134.613C335.92 142.517 327.796 147.207 319.893 145.089L260.391 129.146Z",
    fill: "#82E9CF"
  }))), _rect151 || (_rect151 = /*#__PURE__*/React.createElement("rect", {
    x: 268.179,
    y: 127.198,
    width: 21.8333,
    height: 69.3987,
    rx: 10.9167,
    transform: "rotate(-75 268.179 127.198)",
    fill: "#72D3B8"
  })), _rect152 || (_rect152 = /*#__PURE__*/React.createElement("rect", {
    x: 278.777,
    y: 126.807,
    width: 15.5952,
    height: 59.2618,
    rx: 7.79761,
    transform: "rotate(-75 278.777 126.807)",
    fill: "#82E9CF"
  })), _g105 || (_g105 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter104_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M273.518 173.158C265.614 175.276 257.49 170.586 255.373 162.682V162.682C253.255 154.779 257.945 146.655 265.849 144.537L325.351 128.594C333.254 126.476 341.378 131.166 343.496 139.07V139.07C345.614 146.973 340.923 155.097 333.02 157.215L273.518 173.158Z",
    fill: "#82E9CF"
  }))), _rect153 || (_rect153 = /*#__PURE__*/React.createElement("rect", {
    x: 279.288,
    y: 167.579,
    width: 21.8333,
    height: 69.3987,
    rx: 10.9167,
    transform: "rotate(-105 279.288 167.579)",
    fill: "#72D3B8"
  })), _rect154 || (_rect154 = /*#__PURE__*/React.createElement("rect", {
    x: 288.271,
    y: 161.942,
    width: 15.5952,
    height: 59.2618,
    rx: 7.79761,
    transform: "rotate(-105 288.271 161.942)",
    fill: "#82E9CF"
  })), _g106 || (_g106 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter105_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M283.084 209.685C275.997 213.776 266.936 211.348 262.845 204.262V204.262C258.754 197.176 261.182 188.115 268.268 184.024L321.616 153.223C328.702 149.132 337.763 151.56 341.854 158.646V158.646C345.946 165.732 343.518 174.793 336.432 178.884L283.084 209.685Z",
    fill: "#82E9CF"
  }))), _rect155 || (_rect155 = /*#__PURE__*/React.createElement("rect", {
    x: 287.212,
    y: 202.8,
    width: 21.8333,
    height: 69.3987,
    rx: 10.9167,
    transform: "rotate(-120 287.212 202.8)",
    fill: "#72D3B8"
  })), _rect156 || (_rect156 = /*#__PURE__*/React.createElement("rect", {
    x: 294.431,
    y: 195.028,
    width: 15.5952,
    height: 59.2618,
    rx: 7.79761,
    transform: "rotate(-120 294.431 195.028)",
    fill: "#82E9CF"
  })), _g107 || (_g107 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter106_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M319.697 239.287C315.606 246.373 306.545 248.801 299.458 244.71V244.71C292.372 240.619 289.944 231.558 294.036 224.472L324.836 171.124C328.927 164.038 337.988 161.61 345.075 165.701V165.701C352.161 169.792 354.589 178.853 350.497 185.939L319.697 239.287Z",
    fill: "#82E9CF"
  }))), _rect157 || (_rect157 = /*#__PURE__*/React.createElement("rect", {
    x: 319.829,
    y: 231.26,
    width: 21.8333,
    height: 69.3987,
    rx: 10.9167,
    transform: "rotate(-150 319.829 231.26)",
    fill: "#72D3B8"
  })), _rect158 || (_rect158 = /*#__PURE__*/React.createElement("rect", {
    x: 322.196,
    y: 220.921,
    width: 15.5952,
    height: 59.2618,
    rx: 7.79761,
    transform: "rotate(-150 322.196 220.921)",
    fill: "#82E9CF"
  })), _g108 || (_g108 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter107_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M352.614 253.807C350.496 261.711 342.372 266.401 334.469 264.283V264.283C326.565 262.166 321.875 254.042 323.993 246.138L339.936 186.636C342.054 178.733 350.178 174.042 358.081 176.16V176.16C365.985 178.278 370.675 186.402 368.557 194.305L352.614 253.807Z",
    fill: "#82E9CF"
  }))), _rect159 || (_rect159 = /*#__PURE__*/React.createElement("rect", {
    x: 350.664,
    y: 246.02,
    width: 21.8333,
    height: 69.3987,
    rx: 10.9167,
    transform: "rotate(-165 350.664 246.02)",
    fill: "#72D3B8"
  })), _rect160 || (_rect160 = /*#__PURE__*/React.createElement("rect", {
    x: 350.274,
    y: 235.423,
    width: 15.5952,
    height: 59.2618,
    rx: 7.79761,
    transform: "rotate(-165 350.274 235.423)",
    fill: "#82E9CF"
  })), _g109 || (_g109 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter108_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 391.896,
    y: 271.356,
    width: 29.6309,
    height: 91.232,
    rx: 14.8155,
    transform: "rotate(180 391.896 271.356)",
    fill: "#82E9CF"
  }))), _rect161 || (_rect161 = /*#__PURE__*/React.createElement("rect", {
    x: 387.997,
    y: 249.522,
    width: 21.8333,
    height: 69.3987,
    rx: 10.9167,
    transform: "rotate(180 387.997 249.522)",
    fill: "#72D3B8"
  })), _rect162 || (_rect162 = /*#__PURE__*/React.createElement("rect", {
    x: 384.878,
    y: 239.385,
    width: 15.5952,
    height: 59.2618,
    rx: 7.79761,
    transform: "rotate(180 384.878 239.385)",
    fill: "#82E9CF"
  })), _g110 || (_g110 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter109_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M431.728 248.596C433.846 256.5 429.155 264.624 421.252 266.742V266.742C413.348 268.859 405.224 264.169 403.107 256.265L387.163 196.763C385.045 188.86 389.736 180.736 397.639 178.618V178.618C405.543 176.5 413.667 181.191 415.784 189.094L431.728 248.596Z",
    fill: "#82E9CF"
  }))), _rect163 || (_rect163 = /*#__PURE__*/React.createElement("rect", {
    x: 426.146,
    y: 242.827,
    width: 21.8333,
    height: 69.3987,
    rx: 10.9167,
    transform: "rotate(165 426.146 242.827)",
    fill: "#72D3B8"
  })), _rect164 || (_rect164 = /*#__PURE__*/React.createElement("rect", {
    x: 420.51,
    y: 233.843,
    width: 15.5952,
    height: 59.2618,
    rx: 7.79761,
    transform: "rotate(165 420.51 233.843)",
    fill: "#82E9CF"
  })), _g111 || (_g111 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter110_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M464.024 225.776C468.115 232.862 465.687 241.923 458.601 246.014V246.014C451.515 250.105 442.454 247.677 438.363 240.591L407.562 187.243C403.471 180.157 405.899 171.096 412.985 167.005V167.005C420.071 162.913 429.132 165.341 433.223 172.427L464.024 225.776Z",
    fill: "#82E9CF"
  }))), _rect165 || (_rect165 = /*#__PURE__*/React.createElement("rect", {
    x: 457.139,
    y: 221.647,
    width: 21.8333,
    height: 69.3987,
    rx: 10.9167,
    transform: "rotate(150 457.139 221.647)",
    fill: "#72D3B8"
  })), _rect166 || (_rect166 = /*#__PURE__*/React.createElement("rect", {
    x: 449.368,
    y: 214.427,
    width: 15.5952,
    height: 59.2618,
    rx: 7.79761,
    transform: "rotate(150 449.368 214.427)",
    fill: "#82E9CF"
  })), _g112 || (_g112 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter111_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M486.671 186.823C493.758 190.915 496.185 199.976 492.094 207.062V207.062C488.003 214.148 478.942 216.576 471.856 212.485L418.508 181.684C411.422 177.593 408.994 168.532 413.085 161.446V161.446C417.176 154.36 426.237 151.932 433.323 156.023L486.671 186.823Z",
    fill: "#82E9CF"
  }))), _rect167 || (_rect167 = /*#__PURE__*/React.createElement("rect", {
    x: 478.645,
    y: 186.692,
    width: 21.8333,
    height: 69.3987,
    rx: 10.9167,
    transform: "rotate(120 478.645 186.692)",
    fill: "#72D3B8"
  })), _rect168 || (_rect168 = /*#__PURE__*/React.createElement("rect", {
    x: 468.306,
    y: 184.325,
    width: 15.5952,
    height: 59.2618,
    rx: 7.79761,
    transform: "rotate(120 468.306 184.325)",
    fill: "#82E9CF"
  })), _g113 || (_g113 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter112_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M493.769 150.008C501.673 152.126 506.363 160.25 504.246 168.153V168.153C502.128 176.057 494.004 180.747 486.1 178.629L426.598 162.686C418.695 160.568 414.004 152.444 416.122 144.541V144.541C418.24 136.637 426.364 131.947 434.267 134.064L493.769 150.008Z",
    fill: "#82E9CF"
  }))), _rect169 || (_rect169 = /*#__PURE__*/React.createElement("rect", {
    x: 485.981,
    y: 151.956,
    width: 21.8333,
    height: 69.3987,
    rx: 10.9167,
    transform: "rotate(105 485.981 151.956)",
    fill: "#72D3B8"
  })), _rect170 || (_rect170 = /*#__PURE__*/React.createElement("rect", {
    x: 475.383,
    y: 152.346,
    width: 15.5952,
    height: 59.2618,
    rx: 7.79761,
    transform: "rotate(105 475.383 152.346)",
    fill: "#82E9CF"
  })), _g114 || (_g114 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter113_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M480.642 105.995C488.546 103.878 496.67 108.568 498.788 116.472V116.472C500.905 124.375 496.215 132.499 488.312 134.617L428.809 150.56C420.906 152.678 412.782 147.988 410.664 140.084V140.084C408.547 132.181 413.237 124.057 421.14 121.939L480.642 105.995Z",
    fill: "#82E9CF"
  }))), _rect171 || (_rect171 = /*#__PURE__*/React.createElement("rect", {
    x: 474.872,
    y: 111.575,
    width: 21.8333,
    height: 69.3987,
    rx: 10.9167,
    transform: "rotate(75 474.872 111.575)",
    fill: "#72D3B8"
  })), _rect172 || (_rect172 = /*#__PURE__*/React.createElement("rect", {
    x: 465.889,
    y: 117.212,
    width: 15.5952,
    height: 59.2618,
    rx: 7.79761,
    transform: "rotate(75 465.889 117.212)",
    fill: "#82E9CF"
  })), _g115 || (_g115 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter114_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M471.077 69.469C478.163 65.3778 487.224 67.8057 491.315 74.8918V74.8918C495.406 81.9779 492.978 91.0389 485.892 95.1301L432.544 125.931C425.458 130.022 416.397 127.594 412.306 120.508V120.508C408.215 113.422 410.642 104.361 417.729 100.27L471.077 69.469Z",
    fill: "#82E9CF"
  }))), _rect173 || (_rect173 = /*#__PURE__*/React.createElement("rect", {
    x: 466.949,
    y: 76.3542,
    width: 21.8333,
    height: 69.3987,
    rx: 10.9167,
    transform: "rotate(60 466.949 76.3542)",
    fill: "#72D3B8"
  })), _rect174 || (_rect174 = /*#__PURE__*/React.createElement("rect", {
    x: 459.729,
    y: 84.1257,
    width: 15.5952,
    height: 59.2618,
    rx: 7.79761,
    transform: "rotate(60 459.729 84.1257)",
    fill: "#82E9CF"
  })), _g116 || (_g116 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter115_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M434.463 39.8665C438.555 32.7803 447.616 30.3524 454.702 34.4436V34.4436C461.788 38.5348 464.216 47.5958 460.124 54.6819L429.324 108.03C425.233 115.116 416.172 117.544 409.086 113.453V113.453C402 109.362 399.572 100.301 403.663 93.2146L434.463 39.8665Z",
    fill: "#82E9CF"
  }))), _rect175 || (_rect175 = /*#__PURE__*/React.createElement("rect", {
    x: 434.331,
    y: 47.8933,
    width: 21.8333,
    height: 69.3987,
    rx: 10.9167,
    transform: "rotate(30 434.331 47.8933)",
    fill: "#72D3B8"
  })), _rect176 || (_rect176 = /*#__PURE__*/React.createElement("rect", {
    x: 431.964,
    y: 58.2332,
    width: 15.5952,
    height: 59.2618,
    rx: 7.79761,
    transform: "rotate(30 431.964 58.2332)",
    fill: "#82E9CF"
  })), _g117 || (_g117 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter116_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M401.546 25.3465C403.664 17.443 411.788 12.7527 419.691 14.8704V14.8704C427.595 16.9882 432.285 25.112 430.168 33.0156L414.224 92.5177C412.106 100.421 403.982 105.112 396.079 102.994V102.994C388.175 100.876 383.485 92.7522 385.603 84.8486L401.546 25.3465Z",
    fill: "#82E9CF"
  }))), _rect177 || (_rect177 = /*#__PURE__*/React.createElement("rect", {
    x: 403.496,
    y: 33.1333,
    width: 21.8333,
    height: 69.3987,
    rx: 10.9167,
    transform: "rotate(15 403.496 33.1333)",
    fill: "#72D3B8"
  })), _rect178 || (_rect178 = /*#__PURE__*/React.createElement("rect", {
    x: 403.885,
    y: 43.7312,
    width: 15.5952,
    height: 59.2618,
    rx: 7.79761,
    transform: "rotate(15 403.885 43.7312)",
    fill: "#82E9CF"
  })), _g118 || (_g118 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter117_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M362.265 22.6131C362.265 14.4307 368.898 7.79761 377.08 7.79761V7.79761C385.262 7.79761 391.896 14.4307 391.896 22.6131L391.896 84.2142C391.896 92.3965 385.262 99.0296 377.08 99.0296V99.0296C368.898 99.0296 362.265 92.3965 362.265 84.2142L362.265 22.6131Z",
    fill: "#82E9CF"
  }))), _rect179 || (_rect179 = /*#__PURE__*/React.createElement("rect", {
    x: 366.163,
    y: 29.6316,
    width: 21.8333,
    height: 69.3987,
    rx: 10.9167,
    fill: "#72D3B8"
  })), _rect180 || (_rect180 = /*#__PURE__*/React.createElement("rect", {
    x: 369.282,
    y: 39.7683,
    width: 15.5952,
    height: 59.2618,
    rx: 7.79761,
    fill: "#82E9CF"
  })), _g119 || (_g119 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter118_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 399.693,
    y: 215.214,
    width: 45.2261,
    height: 81.8749,
    rx: 22.6131,
    transform: "rotate(180 399.693 215.214)",
    fill: "#F4D5AD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.896,
    y: 193.382,
    width: 29.6309,
    height: 53.8035,
    rx: 14.8155,
    transform: "rotate(180 391.896 193.382)",
    fill: "#F4C283"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386.438,
    y: 180.124,
    width: 18.7143,
    height: 33.5297,
    rx: 9.35713,
    transform: "rotate(180 386.438 180.124)",
    fill: "#F4D5AD"
  }))), _g120 || (_g120 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter119_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 299.885,
    y: 110.733,
    width: 45.2261,
    height: 81.8749,
    rx: 22.6131,
    transform: "rotate(-45 299.885 110.733)",
    fill: "#F4D5AD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320.837,
    y: 120.659,
    width: 29.6309,
    height: 53.8035,
    rx: 14.8155,
    transform: "rotate(-45 320.837 120.659)",
    fill: "#F4C283"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 334.07,
    y: 126.173,
    width: 18.7143,
    height: 33.5297,
    rx: 9.35713,
    transform: "rotate(-45 334.07 126.173)",
    fill: "#F4D5AD"
  }))), _g121 || (_g121 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter120_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 322.497,
    y: 197.068,
    width: 45.2261,
    height: 81.8749,
    rx: 22.6131,
    transform: "rotate(-120 322.497 197.068)",
    fill: "#F4D5AD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 337.506,
    y: 179.397,
    width: 29.6309,
    height: 53.8035,
    rx: 14.8155,
    transform: "rotate(-120 337.506 179.397)",
    fill: "#F4C283"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.258,
    y: 168.044,
    width: 18.7143,
    height: 33.5297,
    rx: 9.35713,
    transform: "rotate(-120 346.258 168.044)",
    fill: "#F4D5AD"
  }))), _g122 || (_g122 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter121_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 455.004,
    y: 170.545,
    width: 45.2261,
    height: 81.8749,
    rx: 22.6131,
    transform: "rotate(135 455.004 170.545)",
    fill: "#F4D5AD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 434.052,
    y: 160.62,
    width: 29.6309,
    height: 53.8035,
    rx: 14.8155,
    transform: "rotate(135 434.052 160.62)",
    fill: "#F4C283"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 420.818,
    y: 155.106,
    width: 18.7143,
    height: 33.5297,
    rx: 9.35713,
    transform: "rotate(135 420.818 155.106)",
    fill: "#F4D5AD"
  }))), _g123 || (_g123 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter122_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 432.391,
    y: 84.2136,
    width: 45.2261,
    height: 81.8749,
    rx: 22.6131,
    transform: "rotate(60 432.391 84.2136)",
    fill: "#F4D5AD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 417.381,
    y: 101.884,
    width: 29.6309,
    height: 53.8035,
    rx: 14.8155,
    transform: "rotate(60 417.381 101.884)",
    fill: "#F4C283"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 408.63,
    y: 113.239,
    width: 18.7143,
    height: 33.5297,
    rx: 9.35713,
    transform: "rotate(60 408.63 113.239)",
    fill: "#F4D5AD"
  }))), _g124 || (_g124 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter123_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 354.467,
    y: 63.1589,
    width: 45.2261,
    height: 81.8749,
    rx: 22.6131,
    fill: "#F4D5AD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 362.264,
    y: 84.9929,
    width: 29.6309,
    height: 53.8035,
    rx: 14.8155,
    fill: "#F4C283"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 367.723,
    y: 98.2487,
    width: 18.7143,
    height: 33.5297,
    rx: 9.35713,
    fill: "#F4D5AD"
  }))), _g125 || (_g125 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter124_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M377.079 102.147C379.663 102.147 381.758 104.242 381.758 106.826C381.758 108.935 380.362 110.719 378.444 111.302V112.318C388.205 112.806 396.594 118.497 400.899 126.674L402.081 125.992C401.729 124.097 402.579 122.102 404.343 121.084C406.581 119.792 409.442 120.559 410.734 122.797C412.026 125.034 411.258 127.895 409.021 129.187C407.194 130.242 404.951 129.925 403.487 128.555L402.123 129.342C403.323 132.39 403.982 135.711 403.982 139.185C403.982 142.331 403.439 145.349 402.447 148.155L405.791 151.499C407.53 150.668 409.676 150.973 411.116 152.413C412.944 154.24 412.944 157.203 411.116 159.03C409.289 160.857 406.327 160.857 404.5 159.03C403.009 157.538 402.734 155.29 403.678 153.52L401.221 151.063C397.051 159.523 388.567 165.473 378.639 166.041V167.914C380.456 168.556 381.758 170.289 381.758 172.326C381.758 174.91 379.663 177.005 377.079 177.005C374.495 177.005 372.401 174.91 372.401 172.326C372.401 170.217 373.797 168.433 375.715 167.849V166.052C366.972 165.616 359.33 161.005 354.738 154.173L352.805 155.289C353.157 157.184 352.307 159.178 350.543 160.196C348.305 161.488 345.445 160.722 344.153 158.484C342.861 156.246 343.627 153.385 345.864 152.093C347.691 151.038 349.934 151.356 351.399 152.725L353.241 151.661C351.286 147.932 350.178 143.688 350.178 139.185C350.178 136.649 350.529 134.195 351.185 131.869L349.096 129.78C347.357 130.611 345.211 130.306 343.771 128.866C341.944 127.039 341.944 124.076 343.771 122.249C345.598 120.422 348.56 120.422 350.387 122.249C351.878 123.74 352.152 125.989 351.208 127.759L352.255 128.804C356.127 119.556 365.016 112.93 375.52 112.33V111.238C373.703 110.596 372.402 108.863 372.402 106.826C372.402 104.242 374.496 102.147 377.079 102.147Z",
    fill: "white"
  }))), _g126 || (_g126 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter125_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M412.823 126.269C437.853 151.299 447.134 186.114 440.667 218.4C440.535 218.427 440.403 218.45 440.272 218.476L320.618 98.8226C320.644 98.6906 320.668 98.5581 320.694 98.4262C352.98 91.9597 387.793 101.24 412.823 126.269Z",
    fill: "#BDD54E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.065 191.031C323.035 166.001 313.754 131.187 320.221 98.9C320.353 98.8737 320.485 98.8498 320.616 98.824L440.27 218.478C440.244 218.61 440.22 218.742 440.194 218.874C407.908 225.341 373.094 216.06 348.065 191.031Z",
    fill: "#AABF46"
  }))), _g127 || (_g127 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter126_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M212.823 166.269C237.853 191.299 247.134 226.114 240.667 258.4C240.535 258.427 240.403 258.45 240.272 258.476L120.618 138.823C120.644 138.691 120.668 138.558 120.694 138.426C152.98 131.96 187.793 141.24 212.823 166.269Z",
    fill: "#BDD54E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.065 231.031C123.035 206.001 113.754 171.187 120.221 138.9C120.353 138.874 120.485 138.85 120.616 138.824L240.27 258.478C240.244 258.61 240.22 258.742 240.194 258.874C207.908 265.341 173.094 256.06 148.065 231.031Z",
    fill: "#AABF46"
  }))), _g128 || (_g128 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter127_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M341.065 279.564C366.095 254.535 400.909 245.255 433.196 251.721C433.222 251.853 433.246 251.985 433.272 252.116L313.619 371.768C313.487 371.743 313.355 371.719 313.223 371.693C306.757 339.407 316.036 304.593 341.065 279.564Z",
    fill: "#BDD54E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.826 344.322C380.797 369.352 345.982 378.632 313.696 372.165C313.67 372.034 313.646 371.902 313.62 371.77L433.272 252.118C433.404 252.144 433.537 252.167 433.669 252.194C440.135 284.479 430.855 319.293 405.826 344.322Z",
    fill: "#AABF46"
  }))), _g129 || (_g129 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter128_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M399.531 156.3C397.882 150.146 401.534 143.82 407.688 142.171V142.171C413.841 140.522 420.167 144.174 421.816 150.328L434.23 196.658C435.879 202.812 432.227 209.138 426.073 210.787V210.787C419.919 212.435 413.594 208.783 411.945 202.63L399.531 156.3Z",
    fill: "white"
  }))), _rect181 || (_rect181 = /*#__PURE__*/React.createElement("rect", {
    x: 403.877,
    y: 160.792,
    width: 17,
    height: 54.0357,
    rx: 8.5,
    transform: "rotate(-15 403.877 160.792)",
    fill: "#E2E2E2"
  })), _rect182 || (_rect182 = /*#__PURE__*/React.createElement("rect", {
    x: 408.266,
    y: 167.786,
    width: 12.1429,
    height: 46.1429,
    rx: 6.07143,
    transform: "rotate(-15 408.266 167.786)",
    fill: "white"
  })), _g130 || (_g130 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter129_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M374.383 174.067C371.198 168.55 373.088 161.495 378.605 158.309V158.309C384.123 155.124 391.178 157.014 394.364 162.531L418.346 204.07C421.531 209.587 419.641 216.642 414.123 219.828V219.828C408.606 223.013 401.551 221.123 398.365 215.605L374.383 174.067Z",
    fill: "white"
  }))), _rect183 || (_rect183 = /*#__PURE__*/React.createElement("rect", {
    x: 379.744,
    y: 177.282,
    width: 17,
    height: 54.0357,
    rx: 8.5,
    transform: "rotate(-30 379.744 177.282)",
    fill: "#E2E2E2"
  })), _rect184 || (_rect184 = /*#__PURE__*/React.createElement("rect", {
    x: 385.794,
    y: 182.903,
    width: 12.1429,
    height: 46.1429,
    rx: 6.07143,
    transform: "rotate(-30 385.794 182.903)",
    fill: "white"
  })), _g131 || (_g131 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter130_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M356.749 204.396C351.232 201.21 349.341 194.155 352.527 188.637V188.637C355.712 183.12 362.767 181.23 368.285 184.415L409.823 208.397C415.34 211.583 417.231 218.638 414.045 224.155V224.155C410.86 229.673 403.805 231.563 398.287 228.378L356.749 204.396Z",
    fill: "white"
  }))), _rect185 || (_rect185 = /*#__PURE__*/React.createElement("rect", {
    x: 362.999,
    y: 204.499,
    width: 17,
    height: 54.0357,
    rx: 8.5,
    transform: "rotate(-60 362.999 204.499)",
    fill: "#E2E2E2"
  })), _rect186 || (_rect186 = /*#__PURE__*/React.createElement("rect", {
    x: 371.049,
    y: 206.342,
    width: 12.1429,
    height: 46.1429,
    rx: 6.07143,
    transform: "rotate(-60 371.049 206.342)",
    fill: "white"
  })), _g132 || (_g132 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter131_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M351.223 233.062C345.069 231.413 341.417 225.088 343.066 218.934V218.934C344.715 212.78 351.04 209.128 357.194 210.777L403.524 223.191C409.678 224.84 413.33 231.165 411.681 237.319V237.319C410.032 243.473 403.707 247.125 397.553 245.476L351.223 233.062Z",
    fill: "white"
  }))), _rect187 || (_rect187 = /*#__PURE__*/React.createElement("rect", {
    x: 357.287,
    y: 231.545,
    width: 17,
    height: 54.0357,
    rx: 8.5,
    transform: "rotate(-75 357.287 231.545)",
    fill: "#E2E2E2"
  })), _rect188 || (_rect188 = /*#__PURE__*/React.createElement("rect", {
    x: 365.539,
    y: 231.241,
    width: 12.1429,
    height: 46.1429,
    rx: 6.07143,
    transform: "rotate(-75 365.539 231.241)",
    fill: "white"
  })), _g133 || (_g133 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter132_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M361.444 267.333C355.29 268.982 348.965 265.33 347.316 259.176V259.176C345.667 253.022 349.319 246.697 355.473 245.048L401.803 232.634C407.957 230.985 414.282 234.637 415.931 240.791V240.791C417.58 246.945 413.928 253.27 407.774 254.919L361.444 267.333Z",
    fill: "white"
  }))), _rect189 || (_rect189 = /*#__PURE__*/React.createElement("rect", {
    x: 365.937,
    y: 262.987,
    width: 17,
    height: 54.0357,
    rx: 8.5,
    transform: "rotate(-105 365.937 262.987)",
    fill: "#E2E2E2"
  })), _rect190 || (_rect190 = /*#__PURE__*/React.createElement("rect", {
    x: 372.932,
    y: 258.598,
    width: 12.1429,
    height: 46.1429,
    rx: 6.07143,
    transform: "rotate(-105 372.932 258.598)",
    fill: "white"
  })), _g134 || (_g134 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter133_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M368.892 295.772C363.374 298.957 356.319 297.067 353.134 291.55V291.55C349.948 286.032 351.838 278.977 357.356 275.791L398.894 251.809C404.412 248.624 411.467 250.514 414.652 256.032V256.032C417.838 261.549 415.947 268.604 410.43 271.79L368.892 295.772Z",
    fill: "white"
  }))), _rect191 || (_rect191 = /*#__PURE__*/React.createElement("rect", {
    x: 372.106,
    y: 290.411,
    width: 17,
    height: 54.0357,
    rx: 8.5,
    transform: "rotate(-120 372.106 290.411)",
    fill: "#E2E2E2"
  })), _rect192 || (_rect192 = /*#__PURE__*/React.createElement("rect", {
    x: 377.728,
    y: 284.36,
    width: 12.1429,
    height: 46.1429,
    rx: 6.07143,
    transform: "rotate(-120 377.728 284.36)",
    fill: "white"
  })), _g135 || (_g135 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter134_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M397.401 318.821C394.215 324.339 387.16 326.229 381.643 323.043V323.043C376.125 319.858 374.235 312.803 377.42 307.285L401.402 265.747C404.588 260.23 411.643 258.339 417.16 261.525V261.525C422.678 264.71 424.568 271.765 421.383 277.283L397.401 318.821Z",
    fill: "white"
  }))), _rect193 || (_rect193 = /*#__PURE__*/React.createElement("rect", {
    x: 397.504,
    y: 312.571,
    width: 17,
    height: 54.0357,
    rx: 8.5,
    transform: "rotate(-150 397.504 312.571)",
    fill: "#E2E2E2"
  })), _rect194 || (_rect194 = /*#__PURE__*/React.createElement("rect", {
    x: 399.348,
    y: 304.52,
    width: 12.1429,
    height: 46.1429,
    rx: 6.07143,
    transform: "rotate(-150 399.348 304.52)",
    fill: "white"
  })), _g136 || (_g136 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter135_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M423.03 330.128C421.381 336.282 415.055 339.934 408.901 338.285V338.285C402.747 336.636 399.095 330.31 400.744 324.157L413.158 277.827C414.807 271.673 421.133 268.021 427.287 269.67V269.67C433.441 271.319 437.093 277.644 435.444 283.798L423.03 330.128Z",
    fill: "white"
  }))), _rect195 || (_rect195 = /*#__PURE__*/React.createElement("rect", {
    x: 421.512,
    y: 324.063,
    width: 17,
    height: 54.0357,
    rx: 8.5,
    transform: "rotate(-165 421.512 324.063)",
    fill: "#E2E2E2"
  })), _rect196 || (_rect196 = /*#__PURE__*/React.createElement("rect", {
    x: 421.209,
    y: 315.811,
    width: 12.1429,
    height: 46.1429,
    rx: 6.07143,
    transform: "rotate(-165 421.209 315.811)",
    fill: "white"
  })), _g137 || (_g137 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter136_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 453.615,
    y: 343.792,
    width: 23.0714,
    height: 71.0357,
    rx: 11.5357,
    transform: "rotate(180 453.615 343.792)",
    fill: "white"
  }))), _rect197 || (_rect197 = /*#__PURE__*/React.createElement("rect", {
    x: 450.579,
    y: 326.792,
    width: 17,
    height: 54.0357,
    rx: 8.5,
    transform: "rotate(180 450.579 326.792)",
    fill: "#E2E2E2"
  })), _rect198 || (_rect198 = /*#__PURE__*/React.createElement("rect", {
    x: 448.151,
    y: 318.899,
    width: 12.1429,
    height: 46.1429,
    rx: 6.07143,
    transform: "rotate(180 448.151 318.899)",
    fill: "white"
  })), _g138 || (_g138 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter137_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M484.63 326.069C486.279 332.223 482.627 338.548 476.473 340.197V340.197C470.319 341.846 463.993 338.194 462.344 332.04L449.93 285.71C448.281 279.556 451.933 273.231 458.087 271.582V271.582C464.241 269.933 470.567 273.585 472.216 279.739L484.63 326.069Z",
    fill: "white"
  }))), _rect199 || (_rect199 = /*#__PURE__*/React.createElement("rect", {
    x: 480.283,
    y: 321.577,
    width: 17,
    height: 54.0357,
    rx: 8.5,
    transform: "rotate(165 480.283 321.577)",
    fill: "#E2E2E2"
  })), _rect200 || (_rect200 = /*#__PURE__*/React.createElement("rect", {
    x: 475.895,
    y: 314.583,
    width: 12.1429,
    height: 46.1429,
    rx: 6.07143,
    transform: "rotate(165 475.895 314.583)",
    fill: "white"
  })), _g139 || (_g139 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter138_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M509.777 308.302C512.963 313.819 511.072 320.874 505.555 324.06V324.06C500.037 327.245 492.982 325.355 489.797 319.837L465.814 278.299C462.629 272.782 464.519 265.726 470.037 262.541V262.541C475.554 259.355 482.609 261.246 485.795 266.763L509.777 308.302Z",
    fill: "white"
  }))), _rect201 || (_rect201 = /*#__PURE__*/React.createElement("rect", {
    x: 504.416,
    y: 305.087,
    width: 17,
    height: 54.0357,
    rx: 8.5,
    transform: "rotate(150 504.416 305.087)",
    fill: "#E2E2E2"
  })), _rect202 || (_rect202 = /*#__PURE__*/React.createElement("rect", {
    x: 498.366,
    y: 299.466,
    width: 12.1429,
    height: 46.1429,
    rx: 6.07143,
    transform: "rotate(150 498.366 299.466)",
    fill: "white"
  })), _g140 || (_g140 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter139_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M527.411 277.973C532.929 281.159 534.819 288.214 531.634 293.731V293.731C528.448 299.249 521.393 301.139 515.875 297.954L474.337 273.971C468.82 270.786 466.929 263.731 470.115 258.213V258.213C473.3 252.696 480.355 250.805 485.873 253.991L527.411 277.973Z",
    fill: "white"
  }))), _rect203 || (_rect203 = /*#__PURE__*/React.createElement("rect", {
    x: 521.161,
    y: 277.87,
    width: 17,
    height: 54.0357,
    rx: 8.5,
    transform: "rotate(120 521.161 277.87)",
    fill: "#E2E2E2"
  })), _rect204 || (_rect204 = /*#__PURE__*/React.createElement("rect", {
    x: 513.111,
    y: 276.026,
    width: 12.1429,
    height: 46.1429,
    rx: 6.07143,
    transform: "rotate(120 513.111 276.026)",
    fill: "white"
  })), _g141 || (_g141 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter140_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M532.937 249.307C539.091 250.955 542.743 257.281 541.094 263.435V263.435C539.445 269.589 533.12 273.241 526.966 271.592L480.636 259.178C474.482 257.529 470.83 251.203 472.479 245.049V245.049C474.128 238.896 480.454 235.243 486.607 236.892L532.937 249.307Z",
    fill: "white"
  }))), _rect205 || (_rect205 = /*#__PURE__*/React.createElement("rect", {
    x: 526.874,
    y: 250.823,
    width: 17,
    height: 54.0357,
    rx: 8.5,
    transform: "rotate(105 526.874 250.823)",
    fill: "#E2E2E2"
  })), _rect206 || (_rect206 = /*#__PURE__*/React.createElement("rect", {
    x: 518.621,
    y: 251.128,
    width: 12.1429,
    height: 46.1429,
    rx: 6.07143,
    transform: "rotate(105 518.621 251.128)",
    fill: "white"
  })), _g142 || (_g142 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter141_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M522.716 215.036C528.87 213.387 535.195 217.039 536.844 223.193V223.193C538.493 229.347 534.841 235.672 528.687 237.321L482.357 249.735C476.203 251.384 469.878 247.732 468.229 241.578V241.578C466.58 235.424 470.232 229.099 476.386 227.45L522.716 215.036Z",
    fill: "white"
  }))), _rect207 || (_rect207 = /*#__PURE__*/React.createElement("rect", {
    x: 518.224,
    y: 219.382,
    width: 17,
    height: 54.0357,
    rx: 8.5,
    transform: "rotate(75 518.224 219.382)",
    fill: "#E2E2E2"
  })), _rect208 || (_rect208 = /*#__PURE__*/React.createElement("rect", {
    x: 511.229,
    y: 223.771,
    width: 12.1429,
    height: 46.1429,
    rx: 6.07143,
    transform: "rotate(75 511.229 223.771)",
    fill: "white"
  })), _g143 || (_g143 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter142_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M515.269 186.597C520.786 183.411 527.841 185.302 531.027 190.819V190.819C534.212 196.337 532.322 203.392 526.804 206.577L485.266 230.559C479.749 233.745 472.693 231.854 469.508 226.337V226.337C466.322 220.819 468.213 213.764 473.73 210.579L515.269 186.597Z",
    fill: "white"
  }))), _rect209 || (_rect209 = /*#__PURE__*/React.createElement("rect", {
    x: 512.054,
    y: 191.958,
    width: 17,
    height: 54.0357,
    rx: 8.5,
    transform: "rotate(60 512.054 191.958)",
    fill: "#E2E2E2"
  })), _rect210 || (_rect210 = /*#__PURE__*/React.createElement("rect", {
    x: 506.433,
    y: 198.008,
    width: 12.1429,
    height: 46.1429,
    rx: 6.07143,
    transform: "rotate(60 506.433 198.008)",
    fill: "white"
  })), _g144 || (_g144 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter143_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M486.76 163.548C489.946 158.03 497.001 156.14 502.519 159.325V159.325C508.036 162.511 509.926 169.566 506.741 175.083L482.759 216.622C479.573 222.139 472.518 224.029 467.001 220.844V220.844C461.483 217.658 459.593 210.603 462.778 205.086L486.76 163.548Z",
    fill: "white"
  }))), _rect211 || (_rect211 = /*#__PURE__*/React.createElement("rect", {
    x: 486.657,
    y: 169.798,
    width: 17,
    height: 54.0357,
    rx: 8.5,
    transform: "rotate(30 486.657 169.798)",
    fill: "#E2E2E2"
  })), _rect212 || (_rect212 = /*#__PURE__*/React.createElement("rect", {
    x: 484.814,
    y: 177.848,
    width: 12.1429,
    height: 46.1429,
    rx: 6.07143,
    transform: "rotate(30 484.814 177.848)",
    fill: "white"
  })), _g145 || (_g145 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter144_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M461.131 152.241C462.779 146.087 469.105 142.435 475.259 144.084V144.084C481.413 145.733 485.065 152.058 483.416 158.212L471.002 204.542C469.353 210.696 463.027 214.348 456.873 212.699V212.699C450.72 211.05 447.068 204.725 448.716 198.571L461.131 152.241Z",
    fill: "white"
  }))), _rect213 || (_rect213 = /*#__PURE__*/React.createElement("rect", {
    x: 462.648,
    y: 158.305,
    width: 17,
    height: 54.0357,
    rx: 8.5,
    transform: "rotate(15 462.648 158.305)",
    fill: "#E2E2E2"
  })), _rect214 || (_rect214 = /*#__PURE__*/React.createElement("rect", {
    x: 462.952,
    y: 166.557,
    width: 12.1429,
    height: 46.1429,
    rx: 6.07143,
    transform: "rotate(15 462.952 166.557)",
    fill: "white"
  })), _g146 || (_g146 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter145_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M430.545 150.113C430.545 143.742 435.71 138.577 442.081 138.577V138.577C448.452 138.577 453.616 143.742 453.616 150.113L453.616 198.077C453.616 204.448 448.452 209.613 442.081 209.613V209.613C435.71 209.613 430.545 204.448 430.545 198.077L430.545 150.113Z",
    fill: "white"
  }))), _rect215 || (_rect215 = /*#__PURE__*/React.createElement("rect", {
    x: 433.58,
    y: 155.577,
    width: 17,
    height: 54.0357,
    rx: 8.5,
    fill: "#E2E2E2"
  })), _rect216 || (_rect216 = /*#__PURE__*/React.createElement("rect", {
    x: 436.01,
    y: 163.469,
    width: 12.1429,
    height: 46.1429,
    rx: 6.07143,
    fill: "white"
  })), _g147 || (_g147 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter146_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 459.687,
    y: 300.077,
    width: 35.2143,
    height: 63.75,
    rx: 17.6071,
    transform: "rotate(180 459.687 300.077)",
    fill: "#F4D5AD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 453.615,
    y: 283.077,
    width: 23.0714,
    height: 41.8929,
    rx: 11.5357,
    transform: "rotate(180 453.615 283.077)",
    fill: "#F4C283"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 449.365,
    y: 272.757,
    width: 14.5714,
    height: 26.1071,
    rx: 7.28571,
    transform: "rotate(180 449.365 272.757)",
    fill: "#F4D5AD"
  }))), _g148 || (_g148 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter147_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 381.973,
    y: 218.727,
    width: 35.2143,
    height: 63.75,
    rx: 17.6071,
    transform: "rotate(-45 381.973 218.727)",
    fill: "#F4D5AD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 398.286,
    y: 226.456,
    width: 23.0714,
    height: 41.8929,
    rx: 11.5357,
    transform: "rotate(-45 398.286 226.456)",
    fill: "#F4C283"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 408.59,
    y: 230.749,
    width: 14.5714,
    height: 26.1071,
    rx: 7.28571,
    transform: "rotate(-45 408.59 230.749)",
    fill: "#F4D5AD"
  }))), _g149 || (_g149 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter148_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 399.58,
    y: 285.949,
    width: 35.2143,
    height: 63.75,
    rx: 17.6071,
    transform: "rotate(-120 399.58 285.949)",
    fill: "#F4D5AD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 411.267,
    y: 272.191,
    width: 23.0714,
    height: 41.8929,
    rx: 11.5357,
    transform: "rotate(-120 411.267 272.191)",
    fill: "#F4C283"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 418.08,
    y: 263.349,
    width: 14.5714,
    height: 26.1071,
    rx: 7.28571,
    transform: "rotate(-120 418.08 263.349)",
    fill: "#F4D5AD"
  }))), _g150 || (_g150 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter149_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 502.753,
    y: 265.298,
    width: 35.2143,
    height: 63.75,
    rx: 17.6071,
    transform: "rotate(135 502.753 265.298)",
    fill: "#F4D5AD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 486.439,
    y: 257.569,
    width: 23.0714,
    height: 41.8929,
    rx: 11.5357,
    transform: "rotate(135 486.439 257.569)",
    fill: "#F4C283"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 476.135,
    y: 253.278,
    width: 14.5714,
    height: 26.1071,
    rx: 7.28571,
    transform: "rotate(135 476.135 253.278)",
    fill: "#F4D5AD"
  }))), _g151 || (_g151 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter150_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 485.146,
    y: 198.077,
    width: 35.2143,
    height: 63.75,
    rx: 17.6071,
    transform: "rotate(60 485.146 198.077)",
    fill: "#F4D5AD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 473.46,
    y: 211.835,
    width: 23.0714,
    height: 41.8929,
    rx: 11.5357,
    transform: "rotate(60 473.46 211.835)",
    fill: "#F4C283"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 466.646,
    y: 220.677,
    width: 14.5714,
    height: 26.1071,
    rx: 7.28571,
    transform: "rotate(60 466.646 220.677)",
    fill: "#F4D5AD"
  }))), _g152 || (_g152 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter151_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 424.473,
    y: 181.684,
    width: 35.2143,
    height: 63.75,
    rx: 17.6071,
    fill: "#F4D5AD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 430.544,
    y: 198.684,
    width: 23.0714,
    height: 41.8929,
    rx: 11.5357,
    fill: "#F4C283"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 434.794,
    y: 209.007,
    width: 14.5714,
    height: 26.1071,
    rx: 7.28571,
    fill: "#F4D5AD"
  }))), _g153 || (_g153 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter152_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M442.081 212.042C444.092 212.042 445.723 213.673 445.723 215.684C445.723 217.327 444.636 218.716 443.142 219.171V219.961C450.742 220.34 457.274 224.771 460.625 231.137L461.546 230.606C461.272 229.131 461.934 227.578 463.308 226.785C465.05 225.779 467.278 226.377 468.284 228.119C469.289 229.861 468.693 232.089 466.951 233.094C465.528 233.916 463.783 233.669 462.642 232.602L461.58 233.216C462.514 235.589 463.027 238.175 463.027 240.881C463.027 243.329 462.605 245.68 461.833 247.864L464.435 250.467C465.789 249.82 467.46 250.057 468.582 251.178C470.004 252.601 470.004 254.908 468.582 256.331C467.159 257.753 464.853 257.753 463.43 256.331C462.269 255.169 462.055 253.418 462.79 252.041L460.877 250.129C457.63 256.716 451.025 261.349 443.294 261.791V263.249C444.709 263.749 445.723 265.098 445.723 266.684C445.723 268.696 444.091 270.327 442.08 270.327C440.068 270.327 438.437 268.696 438.437 266.684C438.437 265.042 439.524 263.653 441.018 263.198V261.8C434.21 261.46 428.258 257.871 424.682 252.551L423.179 253.419C423.454 254.894 422.792 256.447 421.418 257.24C419.676 258.246 417.448 257.648 416.442 255.906C415.436 254.164 416.033 251.936 417.775 250.93C419.197 250.109 420.944 250.356 422.084 251.423L423.518 250.594C421.996 247.69 421.133 244.386 421.133 240.881C421.133 238.906 421.407 236.995 421.917 235.184L420.292 233.558C418.937 234.205 417.266 233.968 416.144 232.846C414.722 231.424 414.722 229.117 416.144 227.694C417.567 226.271 419.874 226.272 421.296 227.694C422.458 228.855 422.671 230.606 421.936 231.984L422.75 232.799C425.765 225.597 432.687 220.437 440.866 219.969V219.12C439.451 218.62 438.437 217.27 438.437 215.684C438.437 213.673 440.069 212.042 442.081 212.042Z",
    fill: "white"
  }))), _g154 || (_g154 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter153_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.393 46.748C67.6091 40.0907 71.5599 33.2478 78.2172 31.464V31.464C84.8744 29.6802 91.7173 33.6309 93.5011 40.2882L106.931 90.4078C108.714 97.0651 104.764 103.908 98.1064 105.692V105.692C91.4491 107.476 84.6063 103.525 82.8225 96.8675L69.393 46.748Z",
    fill: "#EA8998"
  }))), _rect217 || (_rect217 = /*#__PURE__*/React.createElement("rect", {
    x: 74.0947,
    y: 51.6079,
    width: 18.3905,
    height: 58.4556,
    rx: 9.19527,
    transform: "rotate(-15 74.0947 51.6079)",
    fill: "#E1798C"
  })), _rect218 || (_rect218 = /*#__PURE__*/React.createElement("rect", {
    x: 78.8428,
    y: 59.1745,
    width: 13.1361,
    height: 49.9172,
    rx: 6.56805,
    transform: "rotate(-15 78.8428 59.1745)",
    fill: "#EA8998"
  })), _g155 || (_g155 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter154_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.1898 65.9699C38.7438 60.0012 40.7888 52.369 46.7576 48.9229V48.9229C52.7263 45.4768 60.3585 47.5219 63.8046 53.4906L89.7484 98.4266C93.1945 104.395 91.1494 112.028 85.1807 115.474V115.474C79.2119 118.92 71.5797 116.875 68.1336 110.906L42.1898 65.9699Z",
    fill: "#EA8998"
  }))), _rect219 || (_rect219 = /*#__PURE__*/React.createElement("rect", {
    x: 47.9893,
    y: 69.4459,
    width: 18.3905,
    height: 58.4556,
    rx: 9.19527,
    transform: "rotate(-30 47.9893 69.4459)",
    fill: "#E1798C"
  })), _rect220 || (_rect220 = /*#__PURE__*/React.createElement("rect", {
    x: 54.5332,
    y: 75.5279,
    width: 13.1361,
    height: 49.9172,
    rx: 6.56805,
    transform: "rotate(-30 54.5332 75.5279)",
    fill: "#EA8998"
  })), _g156 || (_g156 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter155_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.1121 98.7794C17.1433 95.3334 15.0983 87.7012 18.5443 81.7324V81.7324C21.9904 75.7637 29.6226 73.7186 35.5914 77.1647L80.5273 103.108C86.4961 106.555 88.5411 114.187 85.0951 120.155V120.155C81.649 126.124 74.0168 128.169 68.048 124.723L23.1121 98.7794Z",
    fill: "#EA8998"
  }))), _rect221 || (_rect221 = /*#__PURE__*/React.createElement("rect", {
    x: 29.873,
    y: 98.8915,
    width: 18.3905,
    height: 58.4556,
    rx: 9.19527,
    transform: "rotate(-60 29.873 98.8915)",
    fill: "#E1798C"
  })), _rect222 || (_rect222 = /*#__PURE__*/React.createElement("rect", {
    x: 38.5811,
    y: 100.885,
    width: 13.1361,
    height: 49.9172,
    rx: 6.56805,
    transform: "rotate(-60 38.5811 100.885)",
    fill: "#EA8998"
  })), _g157 || (_g157 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter156_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.1341 129.791C10.4769 128.007 6.52614 121.164 8.30996 114.507V114.507C10.0938 107.85 16.9366 103.899 23.5939 105.683L73.7135 119.113C80.3707 120.896 84.3215 127.739 82.5376 134.396V134.396C80.7538 141.054 73.911 145.004 67.2537 143.221L17.1341 129.791Z",
    fill: "#EA8998"
  }))), _rect223 || (_rect223 = /*#__PURE__*/React.createElement("rect", {
    x: 23.6943,
    y: 128.149,
    width: 18.3905,
    height: 58.4556,
    rx: 9.19527,
    transform: "rotate(-75 23.6943 128.149)",
    fill: "#E1798C"
  })), _rect224 || (_rect224 = /*#__PURE__*/React.createElement("rect", {
    x: 32.6221,
    y: 127.821,
    width: 13.1361,
    height: 49.9172,
    rx: 6.56805,
    transform: "rotate(-75 32.6221 127.821)",
    fill: "#EA8998"
  })), _g158 || (_g158 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter157_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.1918 166.865C21.5345 168.649 14.6916 164.698 12.9078 158.041V158.041C11.124 151.383 15.0747 144.54 21.732 142.757L71.8516 129.327C78.5088 127.543 85.3517 131.494 87.1355 138.151V138.151C88.9193 144.809 84.9686 151.651 78.3113 153.435L28.1918 166.865Z",
    fill: "#EA8998"
  }))), _rect225 || (_rect225 = /*#__PURE__*/React.createElement("rect", {
    x: 33.0518,
    y: 162.163,
    width: 18.3905,
    height: 58.4556,
    rx: 9.19527,
    transform: "rotate(-105 33.0518 162.163)",
    fill: "#E1798C"
  })), _rect226 || (_rect226 = /*#__PURE__*/React.createElement("rect", {
    x: 40.6191,
    y: 157.415,
    width: 13.1361,
    height: 49.9172,
    rx: 6.56805,
    transform: "rotate(-105 40.6191 157.415)",
    fill: "#EA8998"
  })), _g159 || (_g159 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter158_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.2488 197.628C30.28 201.074 22.6478 199.029 19.2018 193.061V193.061C15.7557 187.092 17.8007 179.46 23.7695 176.014L68.7055 150.07C74.6742 146.624 82.3064 148.669 85.7525 154.637V154.637C89.1985 160.606 87.1535 168.238 81.1847 171.684L36.2488 197.628Z",
    fill: "#EA8998"
  }))), _rect227 || (_rect227 = /*#__PURE__*/React.createElement("rect", {
    x: 39.7266,
    y: 191.829,
    width: 18.3905,
    height: 58.4556,
    rx: 9.19527,
    transform: "rotate(-120 39.7266 191.829)",
    fill: "#E1798C"
  })), _rect228 || (_rect228 = /*#__PURE__*/React.createElement("rect", {
    x: 45.8076,
    y: 185.284,
    width: 13.1361,
    height: 49.9172,
    rx: 6.56805,
    transform: "rotate(-120 45.8076 185.284)",
    fill: "#EA8998"
  })), _g160 || (_g160 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter159_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.0893 222.564C63.6432 228.533 56.011 230.578 50.0422 227.132V227.132C44.0735 223.686 42.0284 216.054 45.4745 210.085L71.4183 165.149C74.8643 159.18 82.4966 157.135 88.4653 160.581V160.581C94.4341 164.028 96.4791 171.66 93.033 177.628L67.0893 222.564Z",
    fill: "#EA8998"
  }))), _rect229 || (_rect229 = /*#__PURE__*/React.createElement("rect", {
    x: 67.2012,
    y: 215.803,
    width: 18.3905,
    height: 58.4556,
    rx: 9.19527,
    transform: "rotate(-150 67.2012 215.803)",
    fill: "#E1798C"
  })), _rect230 || (_rect230 = /*#__PURE__*/React.createElement("rect", {
    x: 69.1943,
    y: 207.094,
    width: 13.1361,
    height: 49.9172,
    rx: 6.56805,
    transform: "rotate(-150 69.1943 207.094)",
    fill: "#EA8998"
  })), _g161 || (_g161 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter160_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M94.8139 234.796C93.03 241.454 86.1872 245.404 79.5299 243.62V243.62C72.8726 241.837 68.9219 234.994 70.7057 228.337L84.1352 178.217C85.919 171.56 92.7619 167.609 99.4192 169.393V169.393C106.076 171.177 110.027 178.019 108.243 184.677L94.8139 234.796Z",
    fill: "#EA8998"
  }))), _rect231 || (_rect231 = /*#__PURE__*/React.createElement("rect", {
    x: 93.1719,
    y: 228.235,
    width: 18.3905,
    height: 58.4556,
    rx: 9.19527,
    transform: "rotate(-165 93.1719 228.235)",
    fill: "#E1798C"
  })), _rect232 || (_rect232 = /*#__PURE__*/React.createElement("rect", {
    x: 92.8438,
    y: 219.309,
    width: 13.1361,
    height: 49.9172,
    rx: 6.56805,
    transform: "rotate(-165 92.8438 219.309)",
    fill: "#EA8998"
  })), _g162 || (_g162 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter161_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 127.902,
    y: 249.577,
    width: 24.9586,
    height: 76.8462,
    rx: 12.4793,
    transform: "rotate(180 127.902 249.577)",
    fill: "#EA8998"
  }))), _rect233 || (_rect233 = /*#__PURE__*/React.createElement("rect", {
    x: 124.618,
    y: 231.186,
    width: 18.3905,
    height: 58.4556,
    rx: 9.19527,
    transform: "rotate(180 124.618 231.186)",
    fill: "#E1798C"
  })), _rect234 || (_rect234 = /*#__PURE__*/React.createElement("rect", {
    x: 121.991,
    y: 222.647,
    width: 13.1361,
    height: 49.9172,
    rx: 6.56805,
    transform: "rotate(180 121.991 222.647)",
    fill: "#EA8998"
  })), _g163 || (_g163 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter162_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M161.454 230.406C163.238 237.063 159.287 243.906 152.63 245.69V245.69C145.972 247.474 139.129 243.523 137.346 236.866L123.916 186.746C122.132 180.089 126.083 173.246 132.74 171.462V171.462C139.398 169.678 146.24 173.629 148.024 180.286L161.454 230.406Z",
    fill: "#EA8998"
  }))), _rect235 || (_rect235 = /*#__PURE__*/React.createElement("rect", {
    x: 156.752,
    y: 225.546,
    width: 18.3905,
    height: 58.4556,
    rx: 9.19527,
    transform: "rotate(165 156.752 225.546)",
    fill: "#E1798C"
  })), _rect236 || (_rect236 = /*#__PURE__*/React.createElement("rect", {
    x: 152.004,
    y: 217.979,
    width: 13.1361,
    height: 49.9172,
    rx: 6.56805,
    transform: "rotate(165 152.004 217.979)",
    fill: "#EA8998"
  })), _g164 || (_g164 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter163_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M188.657 211.184C192.103 217.153 190.058 224.785 184.089 228.231V228.231C178.12 231.677 170.488 229.632 167.042 223.663L141.098 178.727C137.652 172.758 139.697 165.126 145.666 161.68V161.68C151.635 158.234 159.267 160.279 162.713 166.248L188.657 211.184Z",
    fill: "#EA8998"
  }))), _rect237 || (_rect237 = /*#__PURE__*/React.createElement("rect", {
    x: 182.857,
    y: 207.708,
    width: 18.3905,
    height: 58.4556,
    rx: 9.19527,
    transform: "rotate(150 182.857 207.708)",
    fill: "#E1798C"
  })), _rect238 || (_rect238 = /*#__PURE__*/React.createElement("rect", {
    x: 176.312,
    y: 201.626,
    width: 13.1361,
    height: 49.9172,
    rx: 6.56805,
    transform: "rotate(150 176.312 201.626)",
    fill: "#EA8998"
  })), _g165 || (_g165 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter164_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M207.734 178.374C213.702 181.82 215.747 189.453 212.301 195.421V195.421C208.855 201.39 201.223 203.435 195.254 199.989L150.318 174.045C144.35 170.599 142.305 162.967 145.751 156.998V156.998C149.197 151.03 156.829 148.985 162.798 152.431L207.734 178.374Z",
    fill: "#EA8998"
  }))), _rect239 || (_rect239 = /*#__PURE__*/React.createElement("rect", {
    x: 200.973,
    y: 178.262,
    width: 18.3905,
    height: 58.4556,
    rx: 9.19527,
    transform: "rotate(120 200.973 178.262)",
    fill: "#E1798C"
  })), _rect240 || (_rect240 = /*#__PURE__*/React.createElement("rect", {
    x: 192.265,
    y: 176.268,
    width: 13.1361,
    height: 49.9172,
    rx: 6.56805,
    transform: "rotate(120 192.265 176.268)",
    fill: "#EA8998"
  })), _g166 || (_g166 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter165_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M213.713 147.363C220.37 149.146 224.321 155.989 222.537 162.647V162.647C220.753 169.304 213.91 173.255 207.253 171.471L157.133 158.041C150.476 156.257 146.525 149.415 148.309 142.757V142.757C150.093 136.1 156.936 132.149 163.593 133.933L213.713 147.363Z",
    fill: "#EA8998"
  }))), _rect241 || (_rect241 = /*#__PURE__*/React.createElement("rect", {
    x: 207.152,
    y: 149.005,
    width: 18.3905,
    height: 58.4556,
    rx: 9.19527,
    transform: "rotate(105 207.152 149.005)",
    fill: "#E1798C"
  })), _rect242 || (_rect242 = /*#__PURE__*/React.createElement("rect", {
    x: 198.226,
    y: 149.333,
    width: 13.1361,
    height: 49.9172,
    rx: 6.56805,
    transform: "rotate(105 198.226 149.333)",
    fill: "#EA8998"
  })), _g167 || (_g167 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter166_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M202.655 110.289C209.312 108.505 216.155 112.456 217.939 119.113V119.113C219.723 125.771 215.772 132.613 209.115 134.397L158.995 147.827C152.338 149.611 145.495 145.66 143.711 139.003V139.003C141.927 132.345 145.878 125.502 152.535 123.719L202.655 110.289Z",
    fill: "#EA8998"
  }))), _rect243 || (_rect243 = /*#__PURE__*/React.createElement("rect", {
    x: 197.795,
    y: 114.991,
    width: 18.3905,
    height: 58.4556,
    rx: 9.19527,
    transform: "rotate(75 197.795 114.991)",
    fill: "#E1798C"
  })), _rect244 || (_rect244 = /*#__PURE__*/React.createElement("rect", {
    x: 190.228,
    y: 119.739,
    width: 13.1361,
    height: 49.9172,
    rx: 6.56805,
    transform: "rotate(75 190.228 119.739)",
    fill: "#EA8998"
  })), _g168 || (_g168 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter167_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M194.599 79.5255C200.568 76.0795 208.2 78.1245 211.646 84.0933V84.0933C215.092 90.062 213.047 97.6942 207.078 101.14L162.142 127.084C156.173 130.53 148.541 128.485 145.095 122.516V122.516C141.649 116.548 143.694 108.915 149.663 105.469L194.599 79.5255Z",
    fill: "#EA8998"
  }))), _rect245 || (_rect245 = /*#__PURE__*/React.createElement("rect", {
    x: 191.122,
    y: 85.325,
    width: 18.3905,
    height: 58.4556,
    rx: 9.19527,
    transform: "rotate(60 191.122 85.325)",
    fill: "#E1798C"
  })), _rect246 || (_rect246 = /*#__PURE__*/React.createElement("rect", {
    x: 185.041,
    y: 91.8699,
    width: 13.1361,
    height: 49.9172,
    rx: 6.56805,
    transform: "rotate(60 185.041 91.8699)",
    fill: "#EA8998"
  })), _g169 || (_g169 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter168_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M163.758 54.5894C167.204 48.6206 174.837 46.5756 180.805 50.0216V50.0216C186.774 53.4677 188.819 61.0999 185.373 67.0687L159.429 112.005C155.983 117.973 148.351 120.018 142.382 116.572V116.572C136.414 113.126 134.369 105.494 137.815 99.5253L163.758 54.5894Z",
    fill: "#EA8998"
  }))), _rect247 || (_rect247 = /*#__PURE__*/React.createElement("rect", {
    x: 163.646,
    y: 61.3503,
    width: 18.3905,
    height: 58.4556,
    rx: 9.19527,
    transform: "rotate(30 163.646 61.3503)",
    fill: "#E1798C"
  })), _rect248 || (_rect248 = /*#__PURE__*/React.createElement("rect", {
    x: 161.653,
    y: 70.0593,
    width: 13.1361,
    height: 49.9172,
    rx: 6.56805,
    transform: "rotate(30 161.653 70.0593)",
    fill: "#EA8998"
  })), _g170 || (_g170 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter169_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M136.032 42.3575C137.816 35.7002 144.659 31.7495 151.316 33.5333V33.5333C157.973 35.3172 161.924 42.16 160.14 48.8173L146.71 98.9369C144.927 105.594 138.084 109.545 131.427 107.761V107.761C124.769 105.977 120.819 99.1344 122.602 92.4771L136.032 42.3575Z",
    fill: "#EA8998"
  }))), _rect249 || (_rect249 = /*#__PURE__*/React.createElement("rect", {
    x: 137.674,
    y: 48.9187,
    width: 18.3905,
    height: 58.4556,
    rx: 9.19527,
    transform: "rotate(15 137.674 48.9187)",
    fill: "#E1798C"
  })), _rect250 || (_rect250 = /*#__PURE__*/React.createElement("rect", {
    x: 138.001,
    y: 57.8445,
    width: 13.1361,
    height: 49.9172,
    rx: 6.56805,
    transform: "rotate(15 138.001 57.8445)",
    fill: "#EA8998"
  })), _g171 || (_g171 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter170_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M102.944 40.0562C102.944 33.1641 108.532 27.5769 115.424 27.5769V27.5769C122.316 27.5769 127.903 33.1641 127.903 40.0562L127.903 91.9438C127.903 98.8359 122.316 104.423 115.424 104.423V104.423C108.532 104.423 102.944 98.8359 102.944 91.9438L102.944 40.0562Z",
    fill: "#EA8998"
  }))), _rect251 || (_rect251 = /*#__PURE__*/React.createElement("rect", {
    x: 106.229,
    y: 45.9674,
    width: 18.3905,
    height: 58.4556,
    rx: 9.19527,
    fill: "#E1798C"
  })), _rect252 || (_rect252 = /*#__PURE__*/React.createElement("rect", {
    x: 108.855,
    y: 54.5066,
    width: 13.1361,
    height: 49.9172,
    rx: 6.56805,
    fill: "#EA8998"
  })), _g172 || (_g172 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter171_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 134.471,
    y: 202.288,
    width: 38.0947,
    height: 68.9645,
    rx: 19.0473,
    transform: "rotate(180 134.471 202.288)",
    fill: "#F4D5AD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127.902,
    y: 183.897,
    width: 24.9586,
    height: 45.3195,
    rx: 12.4793,
    transform: "rotate(180 127.902 183.897)",
    fill: "#F4C283"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123.306,
    y: 172.731,
    width: 15.7633,
    height: 28.2426,
    rx: 7.88166,
    transform: "rotate(180 123.306 172.731)",
    fill: "#F4D5AD"
  }))), _g173 || (_g173 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter172_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 50.3994,
    y: 114.282,
    width: 38.0947,
    height: 68.9645,
    rx: 19.0473,
    transform: "rotate(-45 50.3994 114.282)",
    fill: "#F4D5AD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.0469,
    y: 122.643,
    width: 24.9586,
    height: 45.3195,
    rx: 12.4793,
    transform: "rotate(-45 68.0469 122.643)",
    fill: "#F4C283"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.1934,
    y: 127.286,
    width: 15.7633,
    height: 28.2426,
    rx: 7.88166,
    transform: "rotate(-45 79.1934 127.286)",
    fill: "#F4D5AD"
  }))), _g174 || (_g174 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter173_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 69.4473,
    y: 187.003,
    width: 38.0947,
    height: 68.9645,
    rx: 19.0473,
    transform: "rotate(-120 69.4473 187.003)",
    fill: "#F4D5AD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82.0898,
    y: 172.118,
    width: 24.9586,
    height: 45.3195,
    rx: 12.4793,
    transform: "rotate(-120 82.0898 172.118)",
    fill: "#F4C283"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.4609,
    y: 162.553,
    width: 15.7633,
    height: 28.2426,
    rx: 7.88166,
    transform: "rotate(-120 89.4609 162.553)",
    fill: "#F4D5AD"
  }))), _g175 || (_g175 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter174_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 181.06,
    y: 164.664,
    width: 38.0947,
    height: 68.9645,
    rx: 19.0473,
    transform: "rotate(135 181.06 164.664)",
    fill: "#F4D5AD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163.411,
    y: 156.304,
    width: 24.9586,
    height: 45.3195,
    rx: 12.4793,
    transform: "rotate(135 163.411 156.304)",
    fill: "#F4C283"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 152.265,
    y: 151.66,
    width: 15.7633,
    height: 28.2426,
    rx: 7.88166,
    transform: "rotate(135 152.265 151.66)",
    fill: "#F4D5AD"
  }))), _g176 || (_g176 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter175_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 162.012,
    y: 91.9441,
    width: 38.0947,
    height: 68.9645,
    rx: 19.0473,
    transform: "rotate(60 162.012 91.9441)",
    fill: "#F4D5AD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 149.369,
    y: 106.827,
    width: 24.9586,
    height: 45.3195,
    rx: 12.4793,
    transform: "rotate(60 149.369 106.827)",
    fill: "#F4C283"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 141.998,
    y: 116.391,
    width: 15.7633,
    height: 28.2426,
    rx: 7.88166,
    transform: "rotate(60 141.998 116.391)",
    fill: "#F4D5AD"
  }))), _g177 || (_g177 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter176_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 96.376,
    y: 74.2097,
    width: 38.0947,
    height: 68.9645,
    rx: 19.0473,
    fill: "#F4D5AD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102.944,
    y: 92.6006,
    width: 24.9586,
    height: 45.3195,
    rx: 12.4793,
    fill: "#F4C283"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.542,
    y: 103.766,
    width: 15.7633,
    height: 28.2426,
    rx: 7.88166,
    fill: "#F4D5AD"
  }))), _g178 || (_g178 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter177_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.423 107.052C117.599 107.052 119.363 108.816 119.363 110.992C119.363 112.769 118.187 114.272 116.571 114.763V115.619C124.792 116.029 131.858 120.822 135.484 127.709L136.481 127.134C136.185 125.538 136.901 123.859 138.387 123.001C140.271 121.913 142.681 122.558 143.769 124.443C144.858 126.328 144.212 128.738 142.327 129.826C140.788 130.714 138.9 130.447 137.666 129.294L136.516 129.957C137.527 132.525 138.082 135.323 138.082 138.251C138.082 140.899 137.625 143.441 136.79 145.803L139.606 148.62C141.071 147.92 142.878 148.177 144.092 149.39C145.631 150.929 145.631 153.424 144.092 154.963C142.553 156.502 140.057 156.502 138.518 154.963C137.262 153.706 137.032 151.813 137.827 150.323L135.758 148.254C132.245 155.38 125.099 160.393 116.736 160.871V162.447C118.267 162.988 119.363 164.448 119.363 166.164C119.363 168.34 117.599 170.104 115.423 170.104C113.246 170.104 111.482 168.34 111.481 166.164C111.481 164.387 112.657 162.884 114.273 162.392V160.881C106.909 160.513 100.471 156.629 96.6024 150.874L94.9764 151.813C95.273 153.409 94.5569 155.088 93.0712 155.946C91.1863 157.034 88.7766 156.389 87.6883 154.504C86.6001 152.619 87.2459 150.209 89.1307 149.121C90.6694 148.233 92.558 148.5 93.7919 149.653L95.3426 148.757C93.6961 145.616 92.7626 142.043 92.7626 138.251C92.7626 136.114 93.0574 134.046 93.6102 132.086L91.8514 130.327C90.3866 131.027 88.5794 130.77 87.3661 129.556C85.8272 128.017 85.8272 125.523 87.3661 123.984C88.9051 122.445 91.4003 122.445 92.9393 123.984C94.1953 125.24 94.4255 127.134 93.6307 128.624L94.5126 129.506C97.7743 121.715 105.262 116.134 114.109 115.629V114.709C112.579 114.168 111.481 112.708 111.481 110.992C111.482 108.816 113.246 107.052 115.423 107.052Z",
    fill: "#E78999"
  }))), _g179 || (_g179 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter178_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M110.08 208.577C114.338 208.577 117.842 211.803 118.282 215.944C119.586 215.081 121.149 214.577 122.83 214.577C127.386 214.577 131.08 218.271 131.08 222.827C131.08 224.508 130.575 226.07 129.712 227.374C133.854 227.814 137.08 231.318 137.08 235.577C137.08 239.835 133.854 243.339 129.712 243.779C130.575 245.083 131.08 246.646 131.08 248.327C131.08 252.883 127.386 256.577 122.83 256.577C121.149 256.577 119.586 256.072 118.282 255.209C117.842 259.35 114.338 262.577 110.08 262.577C105.822 262.577 102.317 259.35 101.877 255.209C100.573 256.072 99.011 256.577 97.3301 256.577C92.7737 256.577 89.0801 252.883 89.0801 248.327C89.0801 246.646 89.5839 245.083 90.4473 243.779C86.3061 243.338 83.0801 239.835 83.0801 235.577C83.0801 231.319 86.306 227.814 90.4473 227.374C89.5842 226.07 89.0801 224.508 89.0801 222.827C89.0801 218.271 92.7737 214.577 97.3301 214.577C99.0108 214.577 100.573 215.081 101.877 215.944C102.318 211.803 105.822 208.577 110.08 208.577ZM105.532 223.709C105.123 227.561 102.064 230.62 98.2119 231.029C99.0754 232.333 99.5801 233.896 99.5801 235.577C99.5801 237.258 99.0752 238.82 98.2119 240.124C102.064 240.533 105.122 243.593 105.532 247.444C106.836 246.581 108.399 246.077 110.08 246.077C111.761 246.077 113.323 246.581 114.627 247.444C115.037 243.593 118.096 240.533 121.947 240.124C121.084 238.82 120.58 237.258 120.58 235.577C120.58 233.896 121.084 232.333 121.947 231.029C118.096 230.619 115.036 227.56 114.627 223.709C113.323 224.572 111.761 225.077 110.08 225.077C108.399 225.077 106.836 224.572 105.532 223.709Z",
    fill: "white"
  }))), _g180 || (_g180 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter179_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M110.08 216.827C113.036 216.827 115.47 219.066 115.776 221.941C116.682 221.342 117.768 220.993 118.935 220.993C122.098 220.993 124.663 223.558 124.663 226.722C124.663 227.89 124.313 228.975 123.713 229.881C126.589 230.186 128.83 232.621 128.83 235.578C128.83 238.535 126.589 240.968 123.713 241.273C124.313 242.179 124.663 243.264 124.663 244.431C124.663 247.595 122.098 250.16 118.935 250.16C117.767 250.16 116.682 249.809 115.776 249.21C115.471 252.087 113.038 254.328 110.08 254.328C107.122 254.328 104.689 252.087 104.384 249.21C103.478 249.809 102.394 250.16 101.227 250.16C98.0625 250.16 95.4972 247.595 95.4971 244.431C95.4971 243.264 95.8469 242.179 96.4463 241.273C93.5705 240.967 91.3302 238.535 91.3301 235.578C91.3301 232.621 93.5704 230.186 96.4463 229.881C95.8468 228.975 95.4971 227.89 95.4971 226.722C95.4971 223.558 98.0624 220.993 101.227 220.993C102.394 220.993 103.478 221.343 104.384 221.942C104.69 219.067 107.123 216.827 110.08 216.827ZM106.922 227.335C106.637 230.01 104.513 232.134 101.837 232.418C102.437 233.324 102.788 234.41 102.788 235.578C102.788 236.745 102.438 237.829 101.839 238.734C104.514 239.018 106.638 241.144 106.922 243.819C107.827 243.22 108.913 242.87 110.08 242.87C111.247 242.87 112.332 243.22 113.237 243.819C113.521 241.145 115.645 239.019 118.319 238.734C117.721 237.829 117.372 236.744 117.372 235.578C117.372 234.41 117.721 233.324 118.321 232.418C115.647 232.133 113.522 230.009 113.237 227.335C112.332 227.934 111.247 228.285 110.08 228.285C108.913 228.285 107.827 227.934 106.922 227.335Z",
    fill: "#82E9CF"
  }))), _g181 || (_g181 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter180_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 110.08,
    cy: 235.577,
    r: 9,
    fill: "white"
  }))), _g182 || (_g182 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter181_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M215.08 134.577C219.338 134.577 222.842 137.803 223.282 141.944C224.586 141.081 226.149 140.577 227.83 140.577C232.386 140.577 236.08 144.271 236.08 148.827C236.08 150.508 235.575 152.07 234.712 153.374C238.854 153.814 242.08 157.318 242.08 161.577C242.08 165.835 238.854 169.339 234.712 169.779C235.575 171.083 236.08 172.646 236.08 174.327C236.08 178.883 232.386 182.577 227.83 182.577C226.149 182.577 224.586 182.072 223.282 181.209C222.842 185.35 219.338 188.577 215.08 188.577C210.822 188.577 207.317 185.35 206.877 181.209C205.573 182.072 204.011 182.577 202.33 182.577C197.774 182.577 194.08 178.883 194.08 174.327C194.08 172.646 194.584 171.083 195.447 169.779C191.306 169.338 188.08 165.835 188.08 161.577C188.08 157.319 191.306 153.814 195.447 153.374C194.584 152.07 194.08 150.508 194.08 148.827C194.08 144.271 197.774 140.577 202.33 140.577C204.011 140.577 205.573 141.081 206.877 141.944C207.318 137.803 210.822 134.577 215.08 134.577ZM210.532 149.709C210.123 153.561 207.064 156.62 203.212 157.029C204.075 158.333 204.58 159.896 204.58 161.577C204.58 163.258 204.075 164.82 203.212 166.124C207.064 166.533 210.122 169.593 210.532 173.444C211.836 172.581 213.399 172.077 215.08 172.077C216.761 172.077 218.323 172.581 219.627 173.444C220.037 169.593 223.096 166.533 226.947 166.124C226.084 164.82 225.58 163.258 225.58 161.577C225.58 159.896 226.084 158.333 226.947 157.029C223.096 156.619 220.036 153.56 219.627 149.709C218.323 150.572 216.761 151.077 215.08 151.077C213.399 151.077 211.836 150.572 210.532 149.709Z",
    fill: "white"
  }))), _g183 || (_g183 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter182_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M215.08 142.827C218.036 142.827 220.47 145.066 220.776 147.941C221.682 147.342 222.768 146.993 223.935 146.993C227.098 146.993 229.663 149.558 229.663 152.722C229.663 153.89 229.313 154.975 228.713 155.881C231.589 156.186 233.83 158.621 233.83 161.578C233.83 164.535 231.589 166.968 228.713 167.273C229.313 168.179 229.663 169.264 229.663 170.431C229.663 173.595 227.098 176.16 223.935 176.16C222.767 176.16 221.682 175.809 220.776 175.21C220.471 178.087 218.038 180.328 215.08 180.328C212.122 180.328 209.689 178.087 209.384 175.21C208.478 175.809 207.394 176.16 206.227 176.16C203.063 176.16 200.497 173.595 200.497 170.431C200.497 169.264 200.847 168.179 201.446 167.273C198.571 166.967 196.33 164.535 196.33 161.578C196.33 158.621 198.57 156.186 201.446 155.881C200.847 154.975 200.497 153.89 200.497 152.722C200.497 149.558 203.062 146.993 206.227 146.993C207.394 146.993 208.478 147.343 209.384 147.942C209.69 145.067 212.123 142.827 215.08 142.827ZM211.922 153.335C211.637 156.01 209.513 158.134 206.837 158.418C207.437 159.324 207.788 160.41 207.788 161.578C207.788 162.745 207.438 163.829 206.839 164.734C209.514 165.018 211.638 167.144 211.922 169.819C212.827 169.22 213.913 168.87 215.08 168.87C216.247 168.87 217.332 169.22 218.237 169.819C218.521 167.145 220.645 165.019 223.319 164.734C222.721 163.829 222.372 162.744 222.372 161.578C222.372 160.41 222.721 159.324 223.321 158.418C220.647 158.133 218.522 156.009 218.237 153.335C217.332 153.934 216.247 154.285 215.08 154.285C213.913 154.285 212.827 153.934 211.922 153.335Z",
    fill: "#F4D5AD"
  }))), _g184 || (_g184 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter183_d_33274_13134)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 215.08,
    cy: 161.577,
    r: 9,
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_33274_13134",
    x: 141.281,
    y: 203.403,
    width: 45.6451,
    height: 76.5686,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.10714
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.32142
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_33274_13134",
    x: 117.302,
    y: 217.069,
    width: 56.191,
    height: 72.198,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.10714
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.32142
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_33274_13134",
    x: 97.3747,
    y: 240.871,
    width: 72.1988,
    height: 56.1909,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.10714
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.32142
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_33274_13134",
    x: 89.7986,
    y: 265.957,
    width: 76.5689,
    height: 45.6453,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.10714
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.32142
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_33274_13134",
    x: 93.6736,
    y: 285.883,
    width: 76.5679,
    height: 45.6453,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.10714
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.32142
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_33274_13134",
    x: 97.9275,
    y: 302.317,
    width: 72.1978,
    height: 56.191,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.10714
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.32142
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_d_33274_13134",
    x: 120.072,
    y: 311.177,
    width: 56.191,
    height: 72.198,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.10714
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.32142
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_d_33274_13134",
    x: 142.387,
    y: 319.651,
    width: 45.6461,
    height: 76.5686,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.10714
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.32142
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_d_33274_13134",
    x: 169.919,
    y: 322.826,
    width: 34.3218,
    height: 78.0535,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.10714
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.32142
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_d_33274_13134",
    x: 187.234,
    y: 321.396,
    width: 45.6451,
    height: 76.5686,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.10714
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.32142
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_d_33274_13134",
    x: 200.667,
    y: 312.101,
    width: 56.191,
    height: 72.198,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.10714
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.32142
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_d_33274_13134",
    x: 204.587,
    y: 304.306,
    width: 72.1988,
    height: 56.191,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.10714
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.32142
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_d_33274_13134",
    x: 207.793,
    y: 289.766,
    width: 76.5689,
    height: 45.6453,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.10714
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.32142
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter13_d_33274_13134",
    x: 203.919,
    y: 269.84,
    width: 76.5679,
    height: 45.6453,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.10714
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.32142
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter14_d_33274_13134",
    x: 204.035,
    y: 242.86,
    width: 72.1978,
    height: 56.1909,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.10714
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.32142
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter15_d_33274_13134",
    x: 197.897,
    y: 217.993,
    width: 56.191,
    height: 72.198,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.10714
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.32142
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter16_d_33274_13134",
    x: 186.127,
    y: 205.149,
    width: 45.6461,
    height: 76.5686,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.10714
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.32142
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter17_d_33274_13134",
    x: 169.92,
    y: 200.488,
    width: 34.3218,
    height: 78.0535,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.10714
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.32142
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter18_d_33274_13134",
    x: 164.384,
    y: 289.614,
    width: 45.3931,
    height: 71.4106,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.10714
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.32142
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter19_d_33274_13134",
    x: 132.284,
    y: 257.511,
    width: 63.7906,
    height: 63.7902,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.10714
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.32142
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter20_d_33274_13134",
    x: 131.507,
    y: 283.861,
    width: 67.9302,
    height: 58.4071,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.10714
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.32142
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter21_d_33274_13134",
    x: 178.603,
    y: 281.577,
    width: 63.7906,
    height: 63.7902,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.10714
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.32142
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter22_d_33274_13134",
    x: 175.24,
    y: 260.612,
    width: 67.9302,
    height: 58.4071,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.10714
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.32142
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter23_d_33274_13134",
    x: 164.384,
    y: 239.791,
    width: 45.3931,
    height: 71.4106,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.10714
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.32142
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter24_d_33274_13134",
    x: 155.817,
    y: 267.469,
    width: 63.0416,
    height: 66.4283,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.10714
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.32142
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter25_d_33274_13134",
    x: 58.9816,
    y: 177.141,
    width: 42.4548,
    height: 71.2171,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.02976
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.08929
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter26_d_33274_13134",
    x: 36.6798,
    y: 189.849,
    width: 52.2634,
    height: 67.152,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.02976
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.08929
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter27_d_33274_13134",
    x: 18.1447,
    y: 211.989,
    width: 67.1521,
    height: 52.2637,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.02976
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.08929
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter28_d_33274_13134",
    x: 11.0978,
    y: 235.321,
    width: 71.2165,
    height: 42.4551,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.02976
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.08929
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter29_d_33274_13134",
    x: 14.7013,
    y: 253.856,
    width: 71.2175,
    height: 42.4551,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.02976
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.08929
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter30_d_33274_13134",
    x: 18.6583,
    y: 269.142,
    width: 67.1521,
    height: 52.2637,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.02976
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.08929
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter31_d_33274_13134",
    x: 39.254,
    y: 277.38,
    width: 52.2634,
    height: 67.152,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.02976
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.08929
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter32_d_33274_13134",
    x: 60.0119,
    y: 285.265,
    width: 42.4548,
    height: 71.2171,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.02976
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.08929
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter33_d_33274_13134",
    x: 85.6193,
    y: 288.216,
    width: 31.9226,
    height: 72.5982,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.02976
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.08929
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter34_d_33274_13134",
    x: 101.724,
    y: 286.885,
    width: 42.4548,
    height: 71.2171,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.02976
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.08929
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter35_d_33274_13134",
    x: 114.217,
    y: 278.241,
    width: 52.2634,
    height: 67.152,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.02976
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.08929
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter36_d_33274_13134",
    x: 117.863,
    y: 270.992,
    width: 67.1521,
    height: 52.2637,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.02976
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.08929
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter37_d_33274_13134",
    x: 120.846,
    y: 257.468,
    width: 71.2165,
    height: 42.4551,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.02976
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.08929
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter38_d_33274_13134",
    x: 117.241,
    y: 238.933,
    width: 71.2175,
    height: 42.4551,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.02976
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.08929
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter39_d_33274_13134",
    x: 117.35,
    y: 213.839,
    width: 67.1521,
    height: 52.2637,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.02976
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.08929
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter40_d_33274_13134",
    x: 111.643,
    y: 190.71,
    width: 52.2634,
    height: 67.152,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.02976
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.08929
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter41_d_33274_13134",
    x: 100.693,
    y: 178.763,
    width: 42.4548,
    height: 71.2171,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.02976
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.08929
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter42_d_33274_13134",
    x: 85.6193,
    y: 174.428,
    width: 31.9226,
    height: 72.5982,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.02976
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.08929
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter43_d_33274_13134",
    x: 80.4699,
    y: 257.325,
    width: 42.2204,
    height: 66.4196,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.02976
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.08929
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter44_d_33274_13134",
    x: 50.6134,
    y: 227.467,
    width: 59.3318,
    height: 59.3318,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.02976
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.08929
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter45_d_33274_13134",
    x: 49.8917,
    y: 251.974,
    width: 63.1823,
    height: 54.3249,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.02976
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.08929
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter46_d_33274_13134",
    x: 93.6974,
    y: 249.85,
    width: 59.3318,
    height: 59.3318,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.02976
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.08929
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter47_d_33274_13134",
    x: 90.5675,
    y: 230.35,
    width: 63.1823,
    height: 54.3249,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.02976
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.08929
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter48_d_33274_13134",
    x: 80.4708,
    y: 210.985,
    width: 42.2204,
    height: 66.4196,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.02976
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.08929
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter49_d_33274_13134",
    x: 72.5021,
    y: 236.729,
    width: 58.6355,
    height: 61.7849,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.02976
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.08929
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter50_d_33274_13134",
    x: 195.982,
    y: 29.1406,
    width: 42.4548,
    height: 71.2171,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.02976
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.08929
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter51_d_33274_13134",
    x: 173.68,
    y: 41.8495,
    width: 52.2634,
    height: 67.152,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.02976
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.08929
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter52_d_33274_13134",
    x: 155.145,
    y: 63.9888,
    width: 67.1521,
    height: 52.2637,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.02976
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.08929
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter53_d_33274_13134",
    x: 148.098,
    y: 87.3209,
    width: 71.2165,
    height: 42.4551,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.02976
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.08929
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter54_d_33274_13134",
    x: 151.701,
    y: 105.856,
    width: 71.2175,
    height: 42.4551,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.02976
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.08929
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter55_d_33274_13134",
    x: 155.658,
    y: 121.142,
    width: 67.1521,
    height: 52.2637,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.02976
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.08929
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter56_d_33274_13134",
    x: 176.254,
    y: 129.38,
    width: 52.2634,
    height: 67.152,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.02976
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.08929
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter57_d_33274_13134",
    x: 197.012,
    y: 137.265,
    width: 42.4548,
    height: 71.2171,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.02976
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.08929
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter58_d_33274_13134",
    x: 222.619,
    y: 140.216,
    width: 31.9226,
    height: 72.5982,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.02976
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.08929
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter59_d_33274_13134",
    x: 238.724,
    y: 138.885,
    width: 42.4548,
    height: 71.2171,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.02976
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.08929
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter60_d_33274_13134",
    x: 251.217,
    y: 130.241,
    width: 52.2634,
    height: 67.152,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.02976
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.08929
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter61_d_33274_13134",
    x: 254.863,
    y: 122.992,
    width: 67.1521,
    height: 52.2637,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.02976
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.08929
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter62_d_33274_13134",
    x: 257.846,
    y: 109.468,
    width: 71.2165,
    height: 42.4551,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.02976
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.08929
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter63_d_33274_13134",
    x: 254.241,
    y: 90.9329,
    width: 71.2175,
    height: 42.4551,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.02976
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.08929
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter64_d_33274_13134",
    x: 254.35,
    y: 65.8392,
    width: 67.1521,
    height: 52.2637,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.02976
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.08929
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter65_d_33274_13134",
    x: 248.643,
    y: 42.7103,
    width: 52.2634,
    height: 67.152,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.02976
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.08929
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter66_d_33274_13134",
    x: 237.693,
    y: 30.763,
    width: 42.4548,
    height: 71.2171,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.02976
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.08929
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter67_d_33274_13134",
    x: 222.619,
    y: 26.4281,
    width: 31.9226,
    height: 72.5982,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.02976
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.08929
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter68_d_33274_13134",
    x: 217.469,
    y: 109.325,
    width: 42.2204,
    height: 66.4196,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.02976
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.08929
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter69_d_33274_13134",
    x: 187.613,
    y: 79.4673,
    width: 59.3318,
    height: 59.3318,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.02976
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.08929
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter70_d_33274_13134",
    x: 186.891,
    y: 103.974,
    width: 63.1823,
    height: 54.3249,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.02976
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.08929
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter71_d_33274_13134",
    x: 230.696,
    y: 101.85,
    width: 59.3318,
    height: 59.3318,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.02976
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.08929
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter72_d_33274_13134",
    x: 227.567,
    y: 82.3501,
    width: 63.1823,
    height: 54.3249,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.02976
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.08929
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter73_d_33274_13134",
    x: 217.47,
    y: 62.9852,
    width: 42.2204,
    height: 66.4196,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.02976
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.08929
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter74_d_33274_13134",
    x: 209.501,
    y: 88.7289,
    width: 58.6364,
    height: 61.7849,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.02976
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.08929
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter75_d_33274_13134",
    x: 230.439,
    y: 184.115,
    width: 44.8322,
    height: 75.2046,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.08742
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.26226
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter76_d_33274_13134",
    x: 206.89,
    y: 197.538,
    width: 55.1906,
    height: 70.9119,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.08742
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.26226
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter77_d_33274_13134",
    x: 187.315,
    y: 220.917,
    width: 70.9123,
    height: 55.19,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.08742
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.26226
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter78_d_33274_13134",
    x: 179.875,
    y: 245.555,
    width: 75.2043,
    height: 44.8322,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.08742
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.26226
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter79_d_33274_13134",
    x: 183.681,
    y: 265.127,
    width: 75.2043,
    height: 44.8322,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.08742
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.26226
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter80_d_33274_13134",
    x: 187.86,
    y: 281.268,
    width: 70.9113,
    height: 55.19,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.08742
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.26226
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter81_d_33274_13134",
    x: 209.608,
    y: 289.97,
    width: 55.1897,
    height: 70.9119,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.08742
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.26226
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter82_d_33274_13134",
    x: 231.527,
    y: 298.294,
    width: 44.8322,
    height: 75.2046,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.08742
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.26226
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter83_d_33274_13134",
    x: 258.568,
    y: 301.413,
    width: 33.7102,
    height: 76.663,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.08742
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.26226
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter84_d_33274_13134",
    x: 275.574,
    y: 300.009,
    width: 44.8322,
    height: 75.2046,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.08742
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.26226
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter85_d_33274_13134",
    x: 288.767,
    y: 290.879,
    width: 55.1906,
    height: 70.9119,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.08742
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.26226
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter86_d_33274_13134",
    x: 292.618,
    y: 283.222,
    width: 70.9123,
    height: 55.19,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.08742
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.26226
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter87_d_33274_13134",
    x: 295.767,
    y: 268.942,
    width: 75.2043,
    height: 44.8322,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.08742
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.26226
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter88_d_33274_13134",
    x: 291.962,
    y: 249.369,
    width: 75.2043,
    height: 44.8322,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.08742
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.26226
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter89_d_33274_13134",
    x: 292.076,
    y: 222.87,
    width: 70.9113,
    height: 55.19,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.08742
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.26226
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter90_d_33274_13134",
    x: 286.049,
    y: 198.447,
    width: 55.1897,
    height: 70.9119,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.08742
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.26226
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter91_d_33274_13134",
    x: 274.487,
    y: 185.83,
    width: 44.8322,
    height: 75.2046,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.08742
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.26226
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter92_d_33274_13134",
    x: 258.568,
    y: 181.253,
    width: 33.7102,
    height: 76.663,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.08742
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.26226
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter93_d_33274_13134",
    x: 253.132,
    y: 268.791,
    width: 44.5842,
    height: 70.1385,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.08742
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.26226
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter94_d_33274_13134",
    x: 221.602,
    y: 237.261,
    width: 62.6535,
    height: 62.6538,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.08742
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.26226
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter95_d_33274_13134",
    x: 220.84,
    y: 263.141,
    width: 66.7199,
    height: 57.3666,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.08742
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.26226
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter96_d_33274_13134",
    x: 267.098,
    y: 260.896,
    width: 62.6535,
    height: 62.6538,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.08742
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.26226
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter97_d_33274_13134",
    x: 263.794,
    y: 240.305,
    width: 66.7199,
    height: 57.3666,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.08742
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.26226
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter98_d_33274_13134",
    x: 253.132,
    y: 219.857,
    width: 44.5842,
    height: 70.1385,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.08742
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.26226
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter99_d_33274_13134",
    x: 244.718,
    y: 247.044,
    width: 61.9182,
    height: 65.2443,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.08742
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.26226
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter100_d_33274_13134",
    x: 312.567,
    y: 4.1062,
    width: 64.2963,
    height: 107.855,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.55952
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.67857
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter101_d_33274_13134",
    x: 278.791,
    y: 23.3549,
    width: 79.1508,
    height: 101.698,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.55952
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.67857
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter102_d_33274_13134",
    x: 250.721,
    y: 56.8842,
    width: 101.699,
    height: 79.1507,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.55952
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.67857
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter103_d_33274_13134",
    x: 240.049,
    y: 92.2184,
    width: 107.855,
    height: 64.2961,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.55952
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.67857
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter104_d_33274_13134",
    x: 245.507,
    y: 120.287,
    width: 107.854,
    height: 64.2961,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.55952
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.67857
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter105_d_33274_13134",
    x: 251.5,
    y: 143.438,
    width: 101.699,
    height: 79.1507,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.55952
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.67857
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter106_d_33274_13134",
    x: 282.691,
    y: 155.916,
    width: 79.1508,
    height: 101.698,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.55952
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.67857
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter107_d_33274_13134",
    x: 314.127,
    y: 167.854,
    width: 64.2953,
    height: 107.855,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.55952
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.67857
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter108_d_33274_13134",
    x: 352.908,
    y: 172.327,
    width: 48.3451,
    height: 109.946,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.55952
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.67857
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter109_d_33274_13134",
    x: 377.297,
    y: 170.312,
    width: 64.2963,
    height: 107.855,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.55952
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.67857
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter110_d_33274_13134",
    x: 396.218,
    y: 157.22,
    width: 79.1508,
    height: 101.698,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.55952
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.67857
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter111_d_33274_13134",
    x: 401.741,
    y: 146.238,
    width: 101.699,
    height: 79.1507,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.55952
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.67857
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter112_d_33274_13134",
    x: 406.256,
    y: 125.758,
    width: 107.855,
    height: 64.2961,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.55952
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.67857
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter113_d_33274_13134",
    x: 400.799,
    y: 97.6893,
    width: 107.854,
    height: 64.2961,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.55952
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.67857
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter114_d_33274_13134",
    x: 400.961,
    y: 59.684,
    width: 101.699,
    height: 79.1507,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.55952
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.67857
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter115_d_33274_13134",
    x: 392.319,
    y: 24.6587,
    width: 79.1508,
    height: 101.698,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.55952
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.67857
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter116_d_33274_13134",
    x: 375.738,
    y: 6.5643,
    width: 64.2953,
    height: 107.855,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.55952
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.67857
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter117_d_33274_13134",
    x: 352.908,
    y: -0.0000025034,
    width: 48.3451,
    height: 109.946,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.55952
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.67857
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter118_d_33274_13134",
    x: 345.11,
    y: 125.541,
    width: 63.9408,
    height: 100.589,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.55952
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.67857
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter119_d_33274_13134",
    x: 299.894,
    y: 80.3225,
    width: 89.8559,
    height: 89.855,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.55952
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.67857
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter120_d_33274_13134",
    x: 298.8,
    y: 117.439,
    width: 95.6869,
    height: 82.2724,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.55952
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.67857
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter121_d_33274_13134",
    x: 365.139,
    y: 114.22,
    width: 89.8559,
    height: 89.855,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.55952
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.67857
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter122_d_33274_13134",
    x: 360.401,
    y: 84.6892,
    width: 95.6869,
    height: 82.2724,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.55952
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.67857
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter123_d_33274_13134",
    x: 345.11,
    y: 55.3613,
    width: 63.9408,
    height: 100.589,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.55952
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.67857
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter124_d_33274_13134",
    x: 333.043,
    y: 94.3496,
    width: 88.8002,
    height: 93.5717,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.55952
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.67857
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter125_d_33274_13134",
    x: 310.266,
    y: 89.7983,
    width: 140.356,
    height: 140.358,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.32725
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.98174
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter126_d_33274_13134",
    x: 110.266,
    y: 129.798,
    width: 140.356,
    height: 140.358,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.32725
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.98174
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter127_d_33274_13134",
    x: 303.268,
    y: 243.093,
    width: 140.356,
    height: 140.354,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.32725
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.98174
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter128_d_33274_13134",
    x: 391.849,
    y: 135.704,
    width: 50.0626,
    height: 83.9785,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.21429
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.64286
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter129_d_33274_13134",
    x: 365.55,
    y: 150.69,
    width: 61.629,
    height: 79.185,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.21429
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.64286
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter130_d_33274_13134",
    x: 343.694,
    y: 176.796,
    width: 79.1847,
    height: 61.6289,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.21429
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.64286
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter131_d_33274_13134",
    x: 335.384,
    y: 204.309,
    width: 83.9787,
    height: 50.0626,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.21429
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.64286
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter132_d_33274_13134",
    x: 339.634,
    y: 226.166,
    width: 83.9787,
    height: 50.0627,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.21429
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.64286
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter133_d_33274_13134",
    x: 344.3,
    y: 244.191,
    width: 79.1847,
    height: 61.6288,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.21429
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.64286
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter134_d_33274_13134",
    x: 368.587,
    y: 253.906,
    width: 61.629,
    height: 79.185,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.21429
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.64286
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter135_d_33274_13134",
    x: 393.063,
    y: 263.202,
    width: 50.0626,
    height: 83.9785,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.21429
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.64286
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter136_d_33274_13134",
    x: 423.258,
    y: 266.685,
    width: 37.6427,
    height: 85.6071,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.21429
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.64286
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter137_d_33274_13134",
    x: 442.248,
    y: 265.115,
    width: 50.0626,
    height: 83.9785,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.21429
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.64286
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter138_d_33274_13134",
    x: 456.981,
    y: 254.922,
    width: 61.629,
    height: 79.185,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.21429
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.64286
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter139_d_33274_13134",
    x: 461.282,
    y: 246.372,
    width: 79.1847,
    height: 61.6289,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.21429
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.64286
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter140_d_33274_13134",
    x: 464.797,
    y: 230.425,
    width: 83.9787,
    height: 50.0627,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.21429
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.64286
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter141_d_33274_13134",
    x: 460.547,
    y: 208.568,
    width: 83.9787,
    height: 50.0627,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.21429
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.64286
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter142_d_33274_13134",
    x: 460.675,
    y: 178.978,
    width: 79.1847,
    height: 61.6289,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.21429
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.64286
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter143_d_33274_13134",
    x: 453.945,
    y: 151.706,
    width: 61.629,
    height: 79.185,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.21429
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.64286
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter144_d_33274_13134",
    x: 441.035,
    y: 137.616,
    width: 50.0626,
    height: 83.9785,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.21429
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.64286
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter145_d_33274_13134",
    x: 423.259,
    y: 132.505,
    width: 37.6427,
    height: 85.6071,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.21429
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.64286
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter146_d_33274_13134",
    x: 417.187,
    y: 230.255,
    width: 49.7853,
    height: 78.3214,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.21429
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.64286
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter147_d_33274_13134",
    x: 381.98,
    y: 195.049,
    width: 69.964,
    height: 69.9635,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.21429
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.64286
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter148_d_33274_13134",
    x: 381.129,
    y: 223.948,
    width: 74.504,
    height: 64.0595,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.21429
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.64286
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter149_d_33274_13134",
    x: 432.782,
    y: 221.441,
    width: 69.964,
    height: 69.9635,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.21429
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.64286
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter150_d_33274_13134",
    x: 429.093,
    y: 198.447,
    width: 74.504,
    height: 64.0595,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.21429
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.64286
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter151_d_33274_13134",
    x: 417.187,
    y: 175.613,
    width: 49.7853,
    height: 78.3214,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.21429
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.64286
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter152_d_33274_13134",
    x: 407.791,
    y: 205.97,
    width: 69.1427,
    height: 72.8566,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.21429
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.64286
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter153_d_33274_13134",
    x: 61.0832,
    y: 24.4677,
    width: 54.1578,
    height: 90.8476,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.31361
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.94083
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter154_d_33274_13134",
    x: 32.634,
    y: 40.6809,
    width: 66.6705,
    height: 85.662,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.31361
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.94083
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter155_d_33274_13134",
    x: 8.98846,
    y: 68.9226,
    width: 85.6627,
    height: 66.6698,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.31361
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.94083
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter156_d_33274_13134",
    x: 0.000179291,
    y: 98.6867,
    width: 90.8473,
    height: 54.1576,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.31361
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.94083
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter157_d_33274_13134",
    x: 4.59784,
    y: 122.331,
    width: 90.8473,
    height: 54.1576,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.31361
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.94083
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter158_d_33274_13134",
    x: 9.64569,
    y: 141.828,
    width: 85.6627,
    height: 66.6699,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.31361
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.94083
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter159_d_33274_13134",
    x: 35.9191,
    y: 152.339,
    width: 66.6696,
    height: 85.662,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.31361
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.94083
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter160_d_33274_13134",
    x: 62.3957,
    y: 162.396,
    width: 54.1578,
    height: 90.8476,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.31361
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.94083
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter161_d_33274_13134",
    x: 95.0617,
    y: 166.163,
    width: 40.7223,
    height: 92.6095,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.31361
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.94083
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter162_d_33274_13134",
    x: 115.606,
    y: 164.466,
    width: 54.1578,
    height: 90.8476,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.31361
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.94083
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter163_d_33274_13134",
    x: 131.542,
    y: 153.438,
    width: 66.6705,
    height: 85.662,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.31361
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.94083
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter164_d_33274_13134",
    x: 136.195,
    y: 144.189,
    width: 85.6618,
    height: 66.6698,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.31361
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.94083
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter165_d_33274_13134",
    x: 139.999,
    y: 126.937,
    width: 90.8473,
    height: 54.1576,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.31361
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.94083
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter166_d_33274_13134",
    x: 135.402,
    y: 103.293,
    width: 90.8473,
    height: 54.1576,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.31361
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.94083
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter167_d_33274_13134",
    x: 135.539,
    y: 71.2835,
    width: 85.6627,
    height: 66.6699,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.31361
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.94083
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter168_d_33274_13134",
    x: 128.259,
    y: 41.7796,
    width: 66.6696,
    height: 85.662,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.31361
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.94083
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter169_d_33274_13134",
    x: 114.292,
    y: 26.537,
    width: 54.1578,
    height: 90.8476,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.31361
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.94083
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter170_d_33274_13134",
    x: 95.0627,
    y: 21.0089,
    width: 40.7223,
    height: 92.6095,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.31361
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.94083
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter171_d_33274_13134",
    x: 88.4943,
    y: 126.755,
    width: 53.858,
    height: 84.7278,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.31361
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.94083
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter172_d_33274_13134",
    x: 50.4074,
    y: 88.6666,
    width: 75.6862,
    height: 75.6863,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.31361
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.94083
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter173_d_33274_13134",
    x: 49.4865,
    y: 119.93,
    width: 80.5993,
    height: 69.2993,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.31361
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.94083
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter174_d_33274_13134",
    x: 105.365,
    y: 117.22,
    width: 75.6862,
    height: 75.6863,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.31361
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.94083
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter175_d_33274_13134",
    x: 101.373,
    y: 92.3447,
    width: 80.5993,
    height: 69.2993,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.31361
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.94083
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter176_d_33274_13134",
    x: 88.4943,
    y: 67.6417,
    width: 53.858,
    height: 84.7278,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.31361
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.94083
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter177_d_33274_13134",
    x: 78.3303,
    y: 100.483,
    width: 74.7975,
    height: 78.816,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.31361
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.94083
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter178_d_33274_13134",
    x: 74.0801,
    y: 202.577,
    width: 72,
    height: 72,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter179_d_33274_13134",
    x: 82.3301,
    y: 210.827,
    width: 55.5,
    height: 55.501,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter180_d_33274_13134",
    x: 92.0801,
    y: 220.577,
    width: 36,
    height: 36,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter181_d_33274_13134",
    x: 179.08,
    y: 128.577,
    width: 72,
    height: 72,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter182_d_33274_13134",
    x: 187.33,
    y: 136.827,
    width: 55.5,
    height: 55.501,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter183_d_33274_13134",
    x: 197.08,
    y: 146.577,
    width: 36,
    height: 36,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33274_13134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33274_13134",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpringHeader);
export default __webpack_public_path__ + "static/media/springHeader.258ebe2ceefa3ca0d67ed7e47f9165d8.svg";
export { ForwardRef as ReactComponent };